/* Studio (sections/me-v-pack.liquid, member view). The member adds their image once (mx-pack worker /upload),
   browses the whole library in a Pinterest-style grid that keeps loading, filters by category, and taps any
   template to render their image onto it for real (/render: Dynamic Mockups smart objects). A new image costs
   NEW credits ($5, shown as "1 image"); changes to it (rotate, fit, spread, one/all, colours) are free up to a cap.
   The worker is the one that counts.
   Credit packs to buy come from data-buy ("$79|79|variantId~…") and show in the rail.
   Finished images get: Rotate, Fill / Fit, Spread / Repeat (two-page templates), Colours (templates with COLOR
   layers) and Download. Everything made collects in the "Your images" tray in the rail, with Download all.
   Past buyers: /usage returns owned (template uuids they bought before, or 'all') and ownedLeft (free new images left
   this month). Those templates get their own chip (data-owned-chip), shown first under a welcome panel, a Yours tag,
   and cost nothing. Nobody else sees the chip or the panel.
   Free first image: /usage also returns freeLeft (every account's first new image is free, worker FREE_NEW_IMAGES).
   From the home page: a visitor drops their logo there (assets/me-try.js), it waits in localStorage 'mx-try' while they
   sign up, and when the studio opens it's loaded and put straight on a template (landscape: laptop, else billboard).
   Canva-style upgrade (18 Sep): once they've downloaded their free image and have no images left, a two-column "Keep going."
   panel offers the packs (their new mockup on the right). Templates they can't afford show a lock; tapping one, or
   running out, opens the same panel. Buying goes to checkout signed in, then back here (me-after-checkout).
   Video templates (data-videos, keyed by uuid) get "Make a video", which opens the video editor (me-reveal.js) over
   the studio with their image already in. Parts videos use /render like a still; stack videos use /frame, one
   render per frame, 1 image per video. Finished videos go in the tray too. #video opens on the Video chip. */
(function () {
  var BATCH = 24, NEW = 5;
  var ICON = {
    rotate: '<svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true"><path d="M4 12a8 8 0 1 0 2.34-5.66" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/><path d="M4 4v5h5" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    colours: '<svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true"><circle cx="8" cy="9" r="4" fill="#f4b8d0"/><circle cx="16" cy="9" r="4" fill="#9db39a"/><circle cx="12" cy="16" r="4" fill="#141414"/></svg>',
    lock: '<svg viewBox="0 0 24 24" width="13" height="13" aria-hidden="true"><rect x="5" y="11" width="14" height="10" rx="2.5" fill="currentColor"/><path d="M8 11V8a4 4 0 0 1 8 0v3" fill="none" stroke="currentColor" stroke-width="2"/></svg>',
    tick: '<svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    download: '<svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true"><path d="M12 4v11m0 0l-4.5-4.5M12 15l4.5-4.5M5 20h14" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    /* Position: a frame with arrows, for dragging their image around the design area. */
    position: '<svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="4" y="4" width="16" height="16" rx="2"/><path d="M12 9v6M9 12h6"/></svg>'
  };
  /* Each template sits in exactly ONE category (19 Sep, Kaitlin: make sure each mockup is in the right category).
     It used to be word-matching per chip, so MacBooks showed in Paper & print ("book"), newspapers in Apparel
     ("heritage" has "tag") and 22 templates in none. Now catOf() picks the first rule that fits, in CAT_RULES order,
     with CAT_NAMED for names the words get wrong. Anything left over goes in More. New templates fall into place by
     name; check the chips after adding some. */
  var CATEGORIES = [
    ['All', null],
    ['Video', 'video'],
    ['Posters & billboards'],
    ['Paper & print'],
    ['Bags'],
    ['Screens'],
    ['Packaging'],
    ['Apparel'],
    ['More']
  ];
  var CAT_NAMED = {"shopping tote minimal swinging":"Posters & billboards",
    'brick wall': 'Posters & billboards', 'cafe a-frame clean street': 'Posters & billboards', 'city ripped poster sticker': 'Posters & billboards',
    'flash id tag minimal': 'Paper & print', 'newspaper phone booth 01': 'Paper & print', 'newspaper folded in box concrete': 'Paper & print',
    'layered paper light box': 'Paper & print', 'paper scattered light box': 'Paper & print',
    'edgy aesthetic lifestyle': 'Screens', 'fashion shoot tethering monitor': 'Screens', 'casual urban coffee break': 'Packaging', 'heart locket mini pic': 'Apparel',
    'old school explorer vehicle': 'More', 'heart balloon message': 'More', 'concrete path message': 'More',
    'glass texture reflection': 'More', 'cotton texture': 'More'
  };
  var CAT_RULES = [
    ['Screens', /iphone|ipad|macbook|laptop|\bcrt\b|\btv\b|\bphone\b/i],
    ['Bags', /\bbags?\b|\btote\b/i],
    ['Apparel', /t[\s-]?shirt|\bshirt|sweater|\bhat\b|\bcap\b|swing ta[gb]|jeans|\bcotton\b/i],
    ['Packaging', /\bbox(es)?\b|packag|tissue|sticker|label|\bcans?\b|\bcups?\b|matches|coffee beans|sunscreen|egg carton/i],
    ['Posters & billboards', /poster|billboard|\bsigns?\b|signage|mural|\bad\b|advert|mega screen|subway|canvas|a-frame|kiosk|\booh\b|number plate/i],
    ['Paper & print', /paper|newspaper|magazine|\bbooks?\b|card|envelope|flyer|printer|scan|sleeve/i]
  ];
  function catOf(it) {
    if (it._cat) { return it._cat; }
    var n = (it.n || '').toLowerCase(), c = CAT_NAMED[n];
    for (var i = 0; !c && i < CAT_RULES.length; i++) { if (CAT_RULES[i][1].test(n)) { c = CAT_RULES[i][0]; } }
    return (it._cat = c || 'More');
  }
  var NEUTRALS = ['#ffffff', '#141414', '#efe9e1', '#f4d9e3', '#9db39a', '#c9b8a3'];

  function hex(rgb) { return '#' + rgb.map(function (v) { return ('0' + Math.round(v).toString(16)).slice(-2); }).join(''); }

  function detect(img) {
    var n = 64, c = document.createElement('canvas'); c.width = n; c.height = n;
    var ctx = c.getContext('2d', { willReadFrequently: true });
    ctx.drawImage(img, 0, 0, n, n);
    var d = ctx.getImageData(0, 0, n, n).data, edge = [], clear = 0;
    for (var y = 0; y < n; y++) {
      for (var x = 0; x < n; x++) {
        if (x > 1 && x < n - 2 && y > 1 && y < n - 2) { continue; }
        var i = (y * n + x) * 4;
        if (d[i + 3] < 200) { clear++; } else { edge.push([d[i], d[i + 1], d[i + 2]]); }
      }
    }
    /* Fill is the standard (6 Oct, Kaitlin: "maybe make standard FILL"). Only a genuinely transparent edge, which
       means a logo rather than a photo, still fits whole: filling would crop it. A photo with a flat-coloured edge
       used to fit too, with that colour behind it, which is why a photo could open not filling its area. */
    if (clear / (clear + edge.length) > 0.2) { return { fit: 'contain', colour: '' }; }
    return { fit: 'cover', colour: '' };
  }

  /* The most common, clearly different colours in their image (no longer shown; kept for later). */
  function palette(img) {
    var n = 40, c = document.createElement('canvas'); c.width = n; c.height = n;
    var ctx = c.getContext('2d', { willReadFrequently: true });
    ctx.drawImage(img, 0, 0, n, n);
    var d = ctx.getImageData(0, 0, n, n).data, buckets = {};
    for (var i = 0; i < d.length; i += 4) {
      if (d[i + 3] < 200) { continue; }
      var key = (d[i] >> 4) + ',' + (d[i + 1] >> 4) + ',' + (d[i + 2] >> 4);
      var b = buckets[key] || (buckets[key] = { n: 0, r: 0, g: 0, b: 0 });
      b.n++; b.r += d[i]; b.g += d[i + 1]; b.b += d[i + 2];
    }
    var picked = [];
    Object.keys(buckets).map(function (k) { return buckets[k]; }).sort(function (a, b) { return b.n - a.n; }).some(function (b) {
      var col = [b.r / b.n, b.g / b.n, b.b / b.n];
      var far = picked.every(function (p) { return Math.abs(p[0] - col[0]) + Math.abs(p[1] - col[1]) + Math.abs(p[2] - col[2]) > 70; });
      if (far) { picked.push(col); }
      return picked.length >= 5;
    });
    return picked.map(hex);
  }


  function wire(app) {
    if (app.dataset.wired) { return; }
    app.dataset.wired = '1';
    /* Funnel steps (assets/me-track.js). */
    var mark = function (e) { if (window.mxTrack) { window.mxTrack(e); } }, lowMarked = false;
    mark('studio_view');
    var endpoint = app.getAttribute('data-endpoint').replace(/\/$/, '');
    var token = app.getAttribute('data-token');
    /* Guest studio (20 Sep, Kaitlin: "it should take them to editor THEN PLACE IT and then make them sign up AFTER
       they saw it THEN DOWNLOAD after sign up"). No account yet, so there is no token: the worker's /free endpoint
       makes the one image (the billboard, or a MacBook for wide logos) and everything past that asks for an account.
       Their logo is kept in mx-try, so the studio makes it again, full size and free, as soon as they are signed in. */
    var guest = app.getAttribute('data-guest') === '1', guestMade = null;
    var q = function (s) { return app.querySelector(s); };
    var fileInput = q('[data-lib-file]'), drop = q('[data-lib-drop]'), empty = q('[data-lib-empty]'), full = q('[data-lib-full]');
    /* iPhone photos can be HEIC; setFile turns them into a JPEG, so the picker lets them be chosen */
    if (fileInput && !/heic/.test(fileInput.accept)) { fileInput.accept += ',image/heic,image/heif,.heic,.heif'; }
    var preview = q('[data-lib-preview]'), nameEl = q('[data-lib-name]'), hint = q('[data-lib-hint]'), meterEl = q('[data-lib-meter]');
    var err = q('[data-lib-error]'), grid = q('[data-lib-grid]'), more = q('[data-lib-more]'), end = q('[data-lib-end]');
    var chipsEl = q('[data-lib-chips]'), tray = q('[data-lib-tray]'), trayGrid = q('[data-lib-tray-grid]'), trayCount = q('[data-lib-tray-count]'), zipBtn = q('[data-lib-zip]');
    var scroller = q('[data-lib-scroll]');
    var side = q('.mv-lib__side');
    var all = [], items = [], shown = 0, art = null, uploading = null, opts = { fit: 'cover', colour: '' }, ratio = 1, brand = [];
    var remaining = null, made = [];
    var owned = {}, ownsAll = false, ownedLeft = null, cats = [], mineChip = null, dockMark = null, dockGo = null;
    function railPane() { var r = app.querySelector('.mv-studio__rail'); return (r && r.getAttribute('data-pane')) || 'create'; }
    /* Wishlist (21 Sep, Kaitlin: "a wishlist where people can heart images"). Hearted template ids live in this
       browser (localStorage mx-hearts); the Saved chip shows them. */
    var hearts = {}, savedChip = null;
    try { (JSON.parse(localStorage.getItem('mx-hearts') || '[]') || []).forEach(function (u) { hearts[u] = 1; }); } catch (e) { hearts = {}; }
    function heartCount() { return Object.keys(hearts).length; }
    function saveHearts() { try { localStorage.setItem('mx-hearts', JSON.stringify(Object.keys(hearts))); } catch (e) {} if (savedChip) { savedChip.hidden = !heartCount(); } }
    var note = q('[data-lib-note]'), ownedChip = app.getAttribute('data-owned-chip') || 'Bought before';
    /* Show examples (19 Sep, Kaitlin: "a toggle… give me inspo, what does the image look filled"). Every template with
       "f" in me-library.json has a real render with the home page's sample designs, theme asset me-inspo-<uuid>.jpg
       (dm/16-inspo-renders.mjs). They only load once the switch is on. Remembered in localStorage mx-lib-inspo. */
    var inspoBase = app.getAttribute('data-inspo') || '', inspoOn = false;
    /* Example and tile images are built by name, so they miss Liquid's ?v= and browsers keep them for a year.
       data-asset-v is me-library.json's version, so re-rendered images show up (20 Sep: the greige scans looked
       unchanged on Kaitlin's screen). Re-render images and me-library.json together, e.g. 16-inspo-renders --mark. */
    var assetV = app.getAttribute('data-asset-v') || '';
    function assetUrl(name) { return inspoBase + name + (assetV ? '?' + assetV : ''); }
    try { inspoOn = localStorage.getItem('mx-lib-inspo') === '1'; } catch (e) { inspoOn = false; }
    function inspoSrc(item) { return assetUrl('me-inspo-' + item.u + '.jpg'); }
    function loadInspo(fig) { var e = fig._inspo; if (e && !e.getAttribute('src')) { e.src = e._src; } }
    function setInspo(on) {
      inspoOn = on; app.classList.toggle('is-inspo', on);
      if (on) { Array.prototype.forEach.call(grid.querySelectorAll('.mv-lib__tile'), loadInspo); }
    }
    function isOwned(item) { return ownsAll || !!owned[item.u]; }
    /* Owning a template is enough (6 Oct, Kaitlin: "they shouldnt need to top up to use their bought mockups").
       It used to need this month's shared owned allowance as well, so once that ran out every bought mockup in the
       Mine tab said "Top up to use this". The worker no longer charges for one either. */
    function ownedFree(item) { return isOwned(item); }
    var freeLeft = 0, offered = false;
    /* Step guide above the library (19 Sep, Kaitlin: people get confused): 1 add your logo, 2 tap a photo, 3 download.
       queued = a tile tapped before there was a logo (it opens the file picker, then makes that one). */
    var guide = q('[data-lib-guide]'), guideLine = q('[data-lib-guide-line]'), queued = null, libReady = null, mixed = [], starter = null;
    var GUIDE = { 2: 'Now tap any photo. Your logo goes on it in seconds.', 3: 'Looks good. Tap Download to save it.' };
    function step(n) {
      if (!guide) { return; }
      var now = guide.getAttribute('data-step');
      if (now === 'done' && n !== 1) { return; }
      guide.setAttribute('data-step', n);
      if (guideLine && GUIDE[n]) { guideLine.textContent = GUIDE[n]; }
      /* The step banner is hidden now (Kaitlin, 19 Sep: "pop up animations that say do this or that"): coach marks instead. */
      /* No "Now tap a photo." either (3 Nov, Kaitlin: "remove random crap sentences… speak more like an app very
         minimal"). They pick the mockup first now, so it was out of order anyway. */
      coachHide();
      /* No "Looks good. Tap Download" bubble (6 Oct, Kaitlin: "remove looks good pop up just have download"):
         the Download button is right there and the bubble sat on top of it. */
    }

    /* Coach marks: one small dark pop-up at a time, pointing at what to do next. Follows its target as the page
       scrolls, hides when it's off screen, and × turns that one off for the visit. */
    var coachEl = null, coachFor = null, coachOff = {};
    var narrow = function () { return window.matchMedia('(max-width: 899px)').matches; };
    function coachHide() {
      if (!coachEl) { return; }
      var el = coachEl; coachEl = null; coachFor = null;
      el.classList.add('is-out'); setTimeout(function () { el.remove(); }, 220);
    }
    function coachPlace() {
      if (!coachEl || !coachFor) { return; }
      if (!document.body.contains(coachFor)) { coachHide(); return; }
      var r = coachFor.getBoundingClientRect(), side = coachEl.getAttribute('data-side'), w = coachEl.offsetWidth, h = coachEl.offsetHeight, x, y;
      if (side === 'right') { x = r.right + 14; y = r.top + r.height / 2 - h / 2; }
      else if (side === 'bottom') { x = r.left + r.width / 2 - w / 2; y = r.bottom + 12; }
      else { x = r.left + r.width / 2 - w / 2; y = r.top - h - 12; }
      coachEl.style.left = Math.max(8, Math.min(window.innerWidth - w - 8, x)) + 'px';
      coachEl.style.top = Math.max(8, Math.min(window.innerHeight - h - 8, y)) + 'px';
      coachEl.style.visibility = r.bottom < 0 || r.top > window.innerHeight || !r.width ? 'hidden' : 'visible';
    }
    function coach(key, target, title, text, side) {
      coachHide();
      if (!target || coachOff[key]) { return; }
      if (side === 'right' && narrow()) { side = 'bottom'; }
      var el = document.createElement('div');
      el.className = 'mv-coach is-bob'; el.setAttribute('role', 'status'); el.setAttribute('data-side', side);
      el.style.setProperty('--bx', side === 'right' ? '5px' : '0px'); el.style.setProperty('--by', side === 'right' ? '0px' : side === 'top' ? '-4px' : '4px');
      el.innerHTML = '<b></b><span></span><button type="button" class="mv-coach__x" aria-label="Got it">&times;</button>';
      el.querySelector('b').textContent = title; el.querySelector('span').textContent = text;
      el.querySelector('button').addEventListener('click', function () { coachOff[key] = 1; coachHide(); });
      document.body.appendChild(el); coachEl = el; coachFor = target;
      coachPlace();
      return el;
    }
    window.addEventListener('resize', coachPlace);
    window.addEventListener('scroll', coachPlace, { passive: true });
    function isFree(item) { return ownedFree(item) || freeLeft > 0; }
    /* Tiles not made yet say what tapping them costs, and lock when there's nothing left to spend. */
    function lockState(f) {
      if (!f._item) { return; }
      var locked = remaining != null && remaining !== Infinity && remaining < NEW && !isFree(f._item) && !f.classList.contains('is-yours');
      /* signed out: everything except the free one is locked */
      if (guest && starter && f._item.u !== starter.u) { locked = true; }
      f.classList.toggle('is-locked', locked);
      /* signed out, the one free template says so loudly (24 Oct, Kaitlin: "make it clearer that THIS is the trial one
         and is unlocked") */
      var sample = !!(guest && starter && f._item.u === starter.u && !locked);
      f.classList.toggle('is-sample', sample);
      if (f._cost && !f.classList.contains('is-yours')) {
        f._cost.textContent = guest ? (locked ? '' : 'Free') : ownedFree(f._item) ? 'Free' : '';
      }
      var s = f.querySelector('.mv-lib__cta');
      if (s && !f.classList.contains('is-yours')) {
        var lockWords = guest ? 'Unlock · Sign up' : ICON.lock + ' Top up to use this';
        /* A guest has no credits to spend, and the free one IS free, so it must not quote a price: the cost
           label under the photo already said Free while the button said 5 credits (6 Oct). */
        s.innerHTML = locked ? lockWords : sample ? 'Try for free' : 'Use this template <small>' + (guest || ownedFree(f._item) ? 'Free' : NEW + ' credits') + '</small>';
      }
    }
    var photoGen = 0;
    function resetMade() { photoGen++; Array.prototype.forEach.call(app.querySelectorAll('.mv-lib__tile'), function (f) { if (f._reset) { f._reset(); } }); if (tray) { drawTray(); } }
    function refreshCtas() { Array.prototype.forEach.call(grid.querySelectorAll('.mv-lib__tile'), lockState); }
    var currentFile = null, videos = {};
    try { videos = JSON.parse(app.getAttribute('data-videos') || '{}'); } catch (e) { videos = {}; }
    /* Photo | Video folder tabs (19 Sep, Kaitlin: "tabs at top… photo and then video… binder folder tabs"). The Video
       panel belongs to assets/me-video.js, which starts the editor with the studio's image (mxStudioFile).
       #video, or coming back from paying for a video (?resume=1), opens on Video. */
    window.mxStudioFile = function () { return currentFile; };
    (function () {
      var tabs = Array.prototype.slice.call(app.querySelectorAll('[data-lib-tab]'));
      if (!tabs.length) { return; }
      function show(name, keep) {
        tabs.forEach(function (t) {
          var on = t.getAttribute('data-lib-tab') === name;
          t.setAttribute('aria-selected', on ? 'true' : 'false'); t.tabIndex = on ? 0 : -1;
        });
        Array.prototype.forEach.call(app.querySelectorAll('[data-lib-panel]'), function (p) { p.hidden = p.getAttribute('data-lib-panel') !== name; });
        app.setAttribute('data-tab', name);
        if (name === 'video') { coachHide(); }
        if (!keep) {
          try { history.replaceState(null, '', location.pathname + location.search + (name === 'video' ? '#video' : '')); } catch (e) { /* ignore */ }
          if (scroller) { scroller.scrollTop = 0; }
        }
      }
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { show(t.getAttribute('data-lib-tab')); });
        t.addEventListener('keydown', function (e) {
          if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') { return; }
          var next = tabs[(i + (e.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length];
          next.focus(); show(next.getAttribute('data-lib-tab'));
        });
      });
      show(location.hash === '#video' || /[?&]resume=1\b/.test(location.search) ? 'video' : 'photo', true);
    })();
    var pricing = app.getAttribute('data-pricing') || '/pages/membership';
    var packs = (app.getAttribute('data-buy') || '').split('~').filter(Boolean).map(function (x) { var p = x.split('|'); return { price: p[0], credits: p[1], variant: p[2] }; });

    function thumb(u) { return endpoint + '/img?u=' + encodeURIComponent(u); }
    function showError(t) { err.textContent = t; err.hidden = false; }
    /* A request that never arrived. Safari calls it "Load failed", Chrome "Failed to fetch"; neither belongs on
       screen (23 Sep). */
    function offline(e) { return !e || !e.message || /load failed|failed to fetch|networkerror|network error|connection/i.test(e.message); }
    function plainly(e) { return offline(e) ? 'That didn\u2019t reach us. Check your connection and try again.' : e.message; }
    function hideError() { err.hidden = true; }
    /* The balance counts to its new number with a floating +/- chip (21 Sep, "more dopamine"). A top-up since the last
       visit (remembered in localStorage mx-bal) gets its own moment: +80 and a pop-up saying what it makes. */
    var lastBal = null, seenBal = null, bought = null;
    try { seenBal = localStorage.getItem('mx-bal'); seenBal = seenBal == null ? null : Number(seenBal); } catch (e) { seenBal = null; }
    function showBalance(balance) {
      var from = lastBal; lastBal = balance;
      var bEl = meterEl.querySelector('[data-bal]');
      if (from == null && seenBal != null && balance > seenBal) { from = seenBal; }
      try { localStorage.setItem('mx-bal', String(balance)); } catch (e) { /* ignore */ }
      if (from == null || from === balance || !bEl) { if (bEl) { bEl.textContent = balance; } return; }
      var t0 = performance.now(), dur = 650;
      (function step(now) {
        var k = Math.min(1, (now - t0) / dur), e = 1 - Math.pow(1 - k, 3);
        bEl.textContent = Math.round(from + (balance - from) * e);
        if (k < 1) { requestAnimationFrame(step); }
      })(t0);
      setTimeout(function () { bEl.textContent = balance; }, dur + 80); /* lands on the right number even in a hidden tab */
      var chip = document.createElement('span'); chip.className = 'mx-delta' + (balance > from ? ' is-up' : '');
      chip.textContent = (balance > from ? '+' : '−') + Math.abs(balance - from);
      var wallet = meterEl.parentNode; wallet.appendChild(chip); setTimeout(function () { chip.remove(); }, 1500);
      meterEl.classList.remove('mx-bump'); void meterEl.offsetWidth; meterEl.classList.add('mx-bump');
    }
    /* The "+80 credits. That's N more mockups" pop-up is gone (Kaitlin, 25 Sep: "remove pop up that says like ohh
       that x more htings… i have 45 credits and it didnt even calcualte it right"). It counted what was ADDED since
       their last visit, not the balance, so the number never matched the one on screen. The balance row says it. */
    function setMeter(b) {
      if (b.unlimited) { remaining = Infinity; meterEl.innerHTML = '<span class="mx-rows"><span class="mx-row"><span>Credits</span><b data-bal>Unlimited</b></span></span>'; app.classList.remove('is-empty'); return; }
      remaining = Number(b.credits) || 0;
      if (b.bought != null) { bought = Number(b.bought) || 0; }
      if (b.subscribed && !made.length) { app.classList.add('is-subbed'); }
      if (b.ownedLeft != null) { ownedLeft = Number(b.ownedLeft) || 0; }
      if (b.freeLeft != null) { freeLeft = Number(b.freeLeft) || 0; }
      refreshCtas();
      /* One credit system (21 Sep, Kaitlin: "everyone starts with x… then 1 mockup is a certain amount"). The balance
         is their paid credits plus the 5 free starting credits not used yet; a mockup is NEW (5), a video 20. */
      var imgs = Math.floor(remaining / NEW), balance = remaining + freeLeft * NEW;
      /* what the balance is worth, so nobody does maths (21 Sep: "make the whole thing much more clear") */
      var worth = balance >= 20 ? 'That’s ' + Math.floor(balance / NEW) + ' mockups or ' + Math.floor(balance / 20) + (Math.floor(balance / 20) === 1 ? ' video' : ' videos')
        : balance >= NEW ? 'That’s ' + Math.floor(balance / NEW) + (Math.floor(balance / NEW) === 1 ? ' mockup' : ' mockups') : 'Top up to make more';
      var extra = ownedLeft != null ? (ownedLeft > 0 ? (ownsAll ? ' Every template is yours, free.' : ' Your old mockups are free.') : '') : '';
      /* like the video editor panel (21 Sep, Kaitlin: "make the 30 credits thing match the editing vibe"): hairline
         rows, small caps label on the left, the value on the right */
      /* one balance, and what it buys (21 Sep, Kaitlin: "what does all this mean? it's confusing": three rows read like
         three separate balances) */
      var canMock = Math.floor(balance / NEW), canVid = Math.floor(balance / 20);
      var buys = canVid ? 'Enough for ' + canMock + ' mockups or ' + canVid + (canVid === 1 ? ' video.' : ' videos.')
        : canMock ? 'Enough for ' + canMock + (canMock === 1 ? ' mockup.' : ' mockups.') : 'Top up to make more.';
      /* just the number (21 Sep, Kaitlin: "remove this and improve left hand menu"); what it buys is in the title */
      /* Phones: the balance and one Top up button, instead of three pack boxes across the top (23 Sep). */
      /* Nothing bought yet, just the free one: say what it actually is. Printing it as "5 credits" read as a
         balance they could spend anywhere, which it is not (6 Oct, Kaitlin: "5 credits? why is this being apploied
         across all"). */
      var onlyFree = remaining < NEW && freeLeft > 0;
      meterEl.innerHTML = (onlyFree
        ? '<span class="mx-rows"><span class="mx-row" title="On the New York billboard."><span>Free mockup</span><b>1</b></span></span><small>Yours on the New York billboard.</small>'
        : '<span class="mx-rows"><span class="mx-row" title="' + buys + '"><span>Credits</span><b data-bal>' + (lastBal == null ? balance : lastBal) + '</b></span></span>')
        + (packs.length ? '<button type="button" class="mx-topup" data-lib-topup>Top up</button>' : '');
      var topUp = meterEl.querySelector('[data-lib-topup]');
      if (topUp) { topUp.addEventListener('click', function () { openPacks(null, 'topup'); }); }
      showBalance(balance);
      app.classList.toggle('is-empty', remaining < NEW && !freeLeft);
      /* Prices stay out of the way until their free one is used (UX pass, 19 Sep; one free image since 20 Sep). */
      if (buyEl) { buyEl.hidden = freeLeft > 0 && imgs === 0; }
      drawSubscribe(b);
    }
    /* On the email list, one more mockup free (23 Sep, Kaitlin: "subscribe then they get free mock"). Subscribing goes
       through Shopify's own newsletter form, so consent is recorded where Shopify keeps it; then the page reloads and
       the token comes back saying they're subscribed, which is what the worker reads. */
    var subEl = null;
    /* Making an account puts them on the list (23 Sep, Kaitlin: "it will be account creating but also i want them
       added to email list and opted in"), because that is what the free mockup is for. It happens once per browser,
       through Shopify's own newsletter form; the page then reloads so the token says they're subscribed. If it
       doesn't take (form blocked, captcha), the button below is the fallback and nothing loops. */
    function autoJoin(email) {
      var flag = 'mx-joined-' + email;
      try { if (localStorage.getItem(flag)) { return false; } localStorage.setItem(flag, '1'); } catch (e) { return false; }
      var form = new FormData();
      form.append('form_type', 'customer'); form.append('utf8', '✓');
      form.append('contact[email]', email); form.append('contact[accepts_marketing]', 'true'); form.append('contact[tags]', 'newsletter');
      fetch('/contact#contact_form', { method: 'POST', body: form, credentials: 'same-origin' })
        .then(function () { location.reload(); }).catch(function () {});
      return true;
    }
    function drawSubscribe(b) {
      var already = app.getAttribute('data-sub') === '1' || (b && b.subscribed);
      var email = app.getAttribute('data-email') || '';
      if (already || !email || guest) { if (subEl) { subEl.hidden = true; } return; }
      if (autoJoin(email)) { return; }
      if (!subEl) {
        subEl = document.createElement('div');
        subEl.className = 'mv-studio__sub';
        subEl.innerHTML = '<p>Your first mockup is free when you join the list.</p><button type="button" class="mx-topup" data-lib-sub>Join the list</button>';
        /* only shown when the automatic join didn't take */
        subEl.querySelector('[data-lib-sub]').addEventListener('click', function () {
          var btn = subEl.querySelector('[data-lib-sub]');
          btn.disabled = true; btn.textContent = 'Joining…';
          var form = new FormData();
          form.append('form_type', 'customer'); form.append('utf8', '✓');
          form.append('contact[email]', email); form.append('contact[accepts_marketing]', 'true'); form.append('contact[tags]', 'newsletter');
          fetch('/contact#contact_form', { method: 'POST', body: form, credentials: 'same-origin' })
            .then(function () { location.reload(); })
            .catch(function () { btn.disabled = false; btn.textContent = 'Join the list'; showError('That didn’t go through. Try again.'); });
        });
        meterEl.parentNode.insertBefore(subEl, meterEl.nextSibling);
      }
      subEl.hidden = false;
      /* It's the whole reason a new account has nothing free, so point at it once (23 Sep). */
      if (!made.length && !(freeLeft > 0)) {
        setTimeout(function () { coach('join', subEl.querySelector('[data-lib-sub]'), 'One free mockup.', 'Join the list.', narrow() ? 'bottom' : 'right'); }, 700);
      }
    }
    /* Buy credits: the packs in the rail, one tap to checkout. */
    var buyEl = null;
    if (packs.length) {
      buyEl = document.createElement('div'); buyEl.className = 'mv-studio__buy'; buyEl.hidden = true;
      var bh = document.createElement('p'); bh.className = 'mv-studio__buy-head'; bh.textContent = 'Top up'; buyEl.appendChild(bh);
      packs.forEach(function (p) {
        var a = document.createElement('a'); a.className = 'mv-studio__pack'; a.href = '/cart/' + p.variant + ':1';
        a.innerHTML = '<span><i class="mx-coin" aria-hidden="true"></i>' + p.credits + ' credits</span><b>' + p.price + '</b>';
        buyEl.appendChild(a);
      });
      var bn = document.createElement('p'); bn.className = 'mv-studio__buy-note'; bn.textContent = 'Credits last 12 months.'; buyEl.appendChild(bn);
      meterEl.parentNode.insertBefore(buyEl, meterEl.nextSibling);
    }
    /* ---- "Keep going." panel: the packs, Canva-style ---- */
    var packPanel = null, packsKind = '', packPhoto = app.getAttribute('data-pack-photo') || '';
    /* kind 'topup': they tapped Top up themselves, so it isn't "that one was on us" and there may be no photo to show. */
    function openPacks(photo, kind) {
      if (!packs.length || !window.HTMLDialogElement) { return false; }
      packsKind = kind || '';
      if (!packPanel) {
        var pick = packs.length > 1 ? 1 : 0;
        packPanel = document.createElement('dialog'); packPanel.className = 'me mv mv-packs';
        packPanel.innerHTML =
          '<div class="mv-packs__card">' +
            '<div class="mv-packs__left">' +
              '<div class="mv-packs__h" data-packs-h role="heading" aria-level="2">Keep going.</div>' +
              '<p class="mv-packs__sub" data-packs-sub></p>' +
              '<div class="mv-packs__opts" role="radiogroup" aria-label="Top-ups"></div>' +
              '<ul class="mv-packs__ticks" role="list" data-packs-ticks></ul>' +
              '<a class="mv-packs__go" data-packs-go href="#"></a>' +
              '<p class="mv-packs__small" data-packs-small></p>' +
              '<button type="button" class="mv-packs__later" data-packs-close>Maybe later</button>' +
            '</div>' +
            '<div class="mv-packs__right" data-packs-photo></div>' +
            '<button type="button" class="mv-packs__x" data-packs-close aria-label="Close">&times;</button>' +
          '</div>';
        var opts = packPanel.querySelector('.mv-packs__opts'), go = packPanel.querySelector('[data-packs-go]');
        function choose(i) {
          pick = i; packPanel._pick = i;
          Array.prototype.forEach.call(opts.children, function (o, k) { o.setAttribute('aria-checked', k === i ? 'true' : 'false'); });
          var p = packs[i], n = Math.floor(p.credits / NEW);
          if (packsKind === 'guest') { go.href = '#'; go.textContent = 'Start creating'; }
          else { go.href = '/cart/' + p.variant + ':1'; go.textContent = 'Get ' + p.credits + ' credits · ' + p.price; }
        }
        packPanel._choose = choose;
        go.addEventListener('click', function (e) {
          if (packsKind !== 'guest') { return; }
          e.preventDefault(); packPanel.close(); askSignUp(null);
        });
        packs.forEach(function (p, i) {
          var o = document.createElement('button'); o.type = 'button'; o.className = 'mv-packs__opt'; o.setAttribute('role', 'radio');
          var n = Math.floor(p.credits / NEW);
          o.innerHTML = '<i aria-hidden="true"></i><span>' + p.credits + ' credits' + (i === 1 ? ' <em>Most popular</em>' : '') + '</span><b>' + p.price + '</b>';
          o.addEventListener('click', function () { choose(i); });
          opts.appendChild(o);
        });
        choose(pick);
        packPanel.addEventListener('click', function (e) { if (e.target === packPanel || (e.target.closest && e.target.closest('[data-packs-close]'))) { packPanel.close(); } });
        document.body.appendChild(packPanel);
      }
      /* what it says depends on why it opened */
      var bal = remaining == null ? 0 : remaining + freeLeft * NEW;
      if (packPanel._choose) { packPanel._choose(packPanel._pick != null ? packPanel._pick : (packs.length > 1 ? 1 : 0)); }
      packPanel.querySelector('[data-packs-h]').textContent =
        kind === 'guest' ? 'Use this template' : kind === 'topup' ? 'Top up.' : 'Keep going.';
      packPanel.querySelector('[data-packs-sub]').textContent =
        kind === 'guest' ? 'Create your best content yet.'
        : kind === 'topup' ? 'You have ' + bal + (bal === 1 ? ' credit' : ' credits') + '. A mockup is ' + NEW + ', a video 20.'
        : (made.length > 1 ? 'Those were on us.' : 'That one was on us.') + ' Top up and put your brand on the rest of the library, or make a video.';
      /* Signed out, the free one is the billboard and nothing else, so say which (6 Oct, Kaitlin: "change to free
         mockup which is billbaord... otherwise they will pick any mockup"). */
      var ticks = kind === 'guest'
        ? ['Credits are valid for 12 months.', 'One payment. No subscription.']
        : ['A mockup is ' + NEW + ' credits, a video 20', 'Changes are free', 'Big 2000px downloads, ready to post', 'One payment. No subscription.'];
      packPanel.querySelector('[data-packs-ticks]').innerHTML = ticks.map(function (t) { return '<li>' + ICON.tick + '<span>' + t + '</span></li>'; }).join('');
      packPanel.querySelector('[data-packs-small]').textContent = kind === 'guest'
        ? 'Your free mockup is the New York billboard.'
        : 'Use them any time in the next 12 months.';
      var ph = packPanel.querySelector('[data-packs-photo]'), src = photo || (made[0] && made[0].state && made[0].state.url) || packPhoto;
      ph.style.backgroundImage = src ? 'url("' + src + '")' : '';
      /* no photo to show (the Top up button on a fresh visit): drop the pane instead of a grey block */
      ph.hidden = !src;
      packPanel.querySelector('.mv-packs__card').classList.toggle('is-solo', !src);
      if (!packPanel.open) { packPanel.showModal(); mark('packs_shown'); }
      return true;
    }
    function needCredits(message) {
      /* they're out, so the panel talks about topping up rather than "that one was on us" (23 Sep) */
      if (openPacks(null, 'topup')) { hideError(); return; }
      showError(message);
      side.classList.remove('is-nudge'); void side.offsetWidth; side.classList.add('is-nudge');
      if (buyEl) { buyEl.hidden = false; buyEl.classList.remove('is-flash'); void buyEl.offsetWidth; buyEl.classList.add('is-flash'); buyEl._at = Date.now(); buyEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); }
    }
    /* On phones the packs pop up as a sheet; a tap anywhere else puts it away. */
    document.addEventListener('click', function (e) {
      if (buyEl && buyEl.classList.contains('is-flash') && Date.now() - (buyEl._at || 0) > 400 && !buyEl.contains(e.target)) { buyEl.classList.remove('is-flash'); }
    });
    function post(path, body) {
      return fetch(endpoint + path, { method: 'POST', body: body }).then(function (r) { return r.json().then(function (b) { return { ok: r.ok, b: b }; }); });
    }
    /* Every way of saving counts as a download (23 Sep): it used to be recorded only from the tile's button, so the
       tray, Download all and the zip went uncounted and the funnel read far worse than it was. */
    function saveBlob(blob, name) {
      mark('download');
      var a = document.createElement('a'); a.href = URL.createObjectURL(blob); a.download = name;
      document.body.appendChild(a); a.click(); a.remove();
      setTimeout(function () { URL.revokeObjectURL(a.href); }, 4000);
    }
    /* On a phone a finished image goes to the camera roll (3 Nov, Kaitlin: "should save to camera roll"). A download
       link only puts it in Files on an iPhone; the share sheet has Save Image, which is the Photos app. The share has
       to start inside the tap, so the image is fetched ahead (showTools) and handed over straight away. */
    function saveImage(blob, name) {
      var file = narrow() && navigator.canShare && new File([blob], name, { type: blob.type || 'image/jpeg' });
      if (file && navigator.canShare({ files: [file] })) {
        mark('download');
        navigator.share({ files: [file] }).catch(function (e) { if (!e || e.name !== 'AbortError') { saveBlob(blob, name); } });
        return;
      }
      saveBlob(blob, name);
    }
    function fileName(item) { return item.n.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') + '.jpg'; }
    function button(cls, html, label) {
      var b = document.createElement('button'); b.type = 'button'; b.className = cls; b.innerHTML = html;
      if (label) { b.setAttribute('aria-label', label); b.title = label; }
      return b;
    }

    /* No account, no balance to fetch: the free goes are waiting and the meter says how many are left. */
    /* No counting out loud (23 Sep, Kaitlin: "just once they swap too many times pop up create account"): they swap
       photos freely and the sign-up appears when the worker says that's enough. */
    var guestTries = 4, guestShown = null;
    function guestMeter() {
      remaining = Infinity; freeLeft = guestTries > 0 ? 1 : 0;
      /* Was a big "Free" in the balance style, which is sized for a number and left "to try" orphaned next to it
         (6 Oct, Kaitlin: "this free to try thing looks shit"). Now the same ruled row as a member's Credits line. */
      meterEl.innerHTML = '<span class="mx-rows"><span class="mx-row"><span>Free to try</span><b>1 mockup</b></span></span>'
        + '<small>Make an account to download it.</small>' + LOGIN;
      refreshCtas();
    }
    /* Returning members land here signed out too, and the site header (with its Log in) is parked off screen for
       guests, so the studio needs its own (29 Oct, Kaitlin: "what if someone wants to login?"). Same Shopify pop-up,
       worded for someone coming back. */
    var LOGIN = '<a class="mx-login" href="/customer_authentication/login?return_to=%2Fpages%2Fcreator-studio">Log in</a>';
    if (guest) {
      meterEl.addEventListener('click', function (e) {
        if (!e.target.closest('.mx-login')) { return; }
        if (window.mxSignIn && window.mxSignIn('/pages/creator-studio', { heading: 'Welcome back.', sub: 'Log in to get back to your mockups.' })) { e.preventDefault(); }
      });
    }
    var usageReady = guest ? Promise.resolve(guestMeter()) : fetch(endpoint + '/usage?token=' + encodeURIComponent(token)).then(function (r) { return r.json(); })
      .then(function (b) {
        if (b.error) { meterEl.textContent = b.error; return; }
        if (b.owned === 'all') { ownsAll = true; } else { (b.owned || []).forEach(function (u) { owned[u] = true; }); }
        setMeter(b);
        claimRef();
      })
      .catch(function () { meterEl.textContent = 'Could not reach the studio service. Refresh to try again.'; });
    /* Came in on a friend's link (me-track.js keeps ?ref= in localStorage mx-ref): tell the worker once, now there is
       an account to tie it to. The worker decides whether it counts (not their own link, no credits bought before). */
    function claimRef() {
      var code = null;
      try { code = JSON.parse(localStorage.getItem('mx-ref') || 'null'); } catch (e) { code = null; }
      if (!code || !code.c || code.at + 60 * 86400000 < Date.now()) { return; }
      fetch(endpoint + '/ref/claim', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ token: token, code: code.c }) })
        .then(function (r) { return r.json(); })
        .then(function (res) { if (res && (res.ok || res.final)) { try { localStorage.removeItem('mx-ref'); } catch (e) { /* ignore */ } } })
        .catch(function () {});
    }

    /* Images spent somewhere else on the page (a video unlocked with images, me-video.js): refresh the rail. */
    if (!guest) {
      window.addEventListener('mx:credits', function () {
        fetch(endpoint + '/usage?token=' + encodeURIComponent(token)).then(function (r) { return r.json(); })
          .then(function (b) { if (!b.error) { setMeter(b); } }).catch(function () {});
      });
    }

    /* is-pop shows a tile's buttons for a moment after each change, then they go back to hover only. It used to stay on
       for good, so a made tile kept its bubble up with the pointer elsewhere (21 Sep, Kaitlin: "bubble still there"). */
    function popOff(fig) { clearTimeout(fig._popT); fig._popT = setTimeout(function () { fig.classList.remove('is-pop'); }, 2600); }

    /* ---- upload ---- */
    /* Every photo goes up as a plain JPEG, redrawn here (3 Nov, Kaitlin's selfie came out blank: "is it because its a
       HEIC file?"). An iPhone photo can be HEIC, which most browsers can't even show, or a JPEG carrying HDR data and a
       rotation the render server reads differently. Redrawing on a canvas leaves just the picture, upright, in sRGB.
       A PNG is left alone, because a logo's see-through edge matters. HEIC that this browser can't open goes through
       heic2any first. */
    var HEIC_LIB = 'https://cdn.jsdelivr.net/npm/heic2any@0.0.4/dist/heic2any.min.js', heicLib = null;
    function isHeic(f) { return /hei[cf]/i.test(f.type || '') || /\.hei[cf]$/i.test(f.name || ''); }
    function openImg(blob) {
      return new Promise(function (ok, no) {
        var u = URL.createObjectURL(blob), im = new Image();
        im.onload = function () { ok(im); }; im.onerror = function () { URL.revokeObjectURL(u); no(new Error('decode')); };
        im.src = u;
      });
    }
    function fromHeic(f) {
      heicLib = heicLib || new Promise(function (ok, no) {
        var sc = document.createElement('script'); sc.src = HEIC_LIB;
        sc.onload = function () { ok(window.heic2any); }; sc.onerror = function () { heicLib = null; no(new Error('heic lib')); };
        document.head.appendChild(sc);
      });
      return heicLib.then(function (h) { return h({ blob: f, toType: 'image/jpeg', quality: 0.92 }); })
        .then(function (r) { return Array.isArray(r) ? r[0] : r; });
    }
    function plain(f) {
      if (f.type === 'image/png' && !isHeic(f)) { return Promise.resolve(f); }
      if (!isHeic(f) && !/^image\//.test(f.type || '')) { return Promise.reject(new Error('type')); }
      return openImg(f).catch(function (e) { if (isHeic(f)) { return fromHeic(f).then(openImg); } throw e; }).then(function (im) {
        var w = im.naturalWidth, h = im.naturalHeight, k = Math.min(1, 4000 / Math.max(w, h));
        var c = document.createElement('canvas'); c.width = Math.round(w * k); c.height = Math.round(h * k);
        var g = c.getContext('2d'); g.fillStyle = '#fff'; g.fillRect(0, 0, c.width, c.height); g.drawImage(im, 0, 0, c.width, c.height);
        URL.revokeObjectURL(im.src);
        function enc(q) { return new Promise(function (ok) { c.toBlob(ok, 'image/jpeg', q); }); }
        return enc(0.92).then(function (b) { return b && b.size > 7.5 * 1024 * 1024 ? enc(0.8) : b; }).then(function (b) {
          if (!b) { throw new Error('encode'); }
          var name = (f.name || 'photo').replace(/\.[a-z0-9]+$/i, '') + '.jpg';
          return new File([b], name, { type: 'image/jpeg', lastModified: Date.now() });
        });
      });
    }
    function setFile(f) {
      if (!f) { return; }
      if (!f._plain) {
        return plain(f).then(function (p) {
          p._plain = true; if (f._mxId) { p._mxId = f._mxId; }
          return setFile(p);
        }, function () { showError('That photo would not open. Try a JPG or PNG.'); });
      }
      if (!/^image\/(png|jpeg|webp)$/.test(f.type)) { showError('Use a PNG, JPG or WebP.'); return; }
      if (f.size > 8 * 1024 * 1024) { showError('That file is over 8MB. Try a smaller one.'); return; }
      hideError(); art = null; currentFile = f; rememberUpload(f); resetMade();
      if (focusFig && !queued) { var fg = focusFig; queued = function () { if (fg._first) { fg._first(); } }; }
      var loaded = new Promise(function (done) {
        preview.onload = function () {
          ratio = preview.naturalWidth / preview.naturalHeight;
          try { opts = detect(preview); brand = palette(preview); } catch (e) { opts = { fit: 'cover', colour: '' }; brand = []; }
          done();
        };
        preview.onerror = function () { done(); };
      });
      preview.src = URL.createObjectURL(f); nameEl.textContent = f.name;
      /* On a computer the box stays an Upload photo button: the photo itself lives in Uploads, and showing it here
         left it sitting on the left after going back to All mockups (3 Nov, Kaitlin: "it shouldn't do that").
         Phones still show it as the small chip in the top bar. */
      if (narrow()) { empty.hidden = true; full.hidden = false; drop.classList.add('has-file'); }
      app.classList.add('has-art'); refreshCtas();
      if (again) { again.hidden = true; }
      /* The rail says nothing (6 Oct, Kaitlin: "maybe dont say anything?"). "Putting it on now." and
         "Now tap any template." narrated what the screen was already showing. */
      hint.textContent = '';
      step(2);
      if (guest) {
        /* Nothing to save on the server yet: /free takes the file itself. */
        art = 'guest'; uploading = null; mark('upload'); keep('mx-logo', f);
      } else {
        var body = new FormData(); body.append('token', token); body.append('image', f);
        /* One retry: the first try can simply not arrive on a phone (23 Sep, Kaitlin on 5G saw Safari's own
           "Load failed (mx-pack…)" where our message should have been). */
        uploading = post('/upload', body).catch(function (e) { if (!offline(e)) { throw e; } return post('/upload', body); })
          .then(function (res) {
            if (!res.ok) { throw new Error(res.b.error || 'Could not save your image.'); }
            art = res.b.art; setMeter(res.b); mark('upload'); keep('mx-logo', f); return art;
          }).catch(function (e) {
            /* a photo picked again meanwhile has its own upload: an old one failing says nothing */
            if (currentFile === f) { showError(plainly(e)); app.classList.remove('has-art'); refreshCtas(); uploading = null; step(1); }
            throw e;
          });
        uploading.catch(function () {});
      }
      loaded.then(function () {
        if (queued) { var go = queued; queued = null; go(); return; }
        /* Their free first image makes itself, so the first thing they see is their logo on a real photo. */
        if (!pendingFile && libReady) { Promise.all([libReady, usageReady]).then(autoStart); }
      });
      return loaded;
    }
    /* Recent uploads (21 Sep, Kaitlin: "add a section for recently uploaded pics"). The last 12 images they added,
       kept as the original files in this browser (IndexedDB mx-uploads), shown under the drop box. Tapping one uses it
       again, exactly as if they had dropped it in. */
    var RECENT_MAX = 12, recentEl = null, recentGrid = null, recentUrls = [], lastRecTap = 0;
    function recentDb() {
      return new Promise(function (ok, no) {
        if (!window.indexedDB) { no(new Error('no idb')); return; }
        var r = indexedDB.open('mx-uploads', 1);
        r.onupgradeneeded = function () { r.result.createObjectStore('files', { keyPath: 'id' }); };
        r.onsuccess = function () { ok(r.result); }; r.onerror = function () { no(r.error); };
      });
    }
    function recentAll() {
      return recentDb().then(function (db) {
        return new Promise(function (ok) {
          var out = [], req = db.transaction('files').objectStore('files').openCursor();
          req.onsuccess = function () { var c = req.result; if (c) { out.push(c.value); c.continue(); } else { ok(out.sort(function (a, b) { return b.at - a.at; })); } };
          req.onerror = function () { ok([]); };
        });
      }).catch(function () { return []; });
    }
    function recentPut(rec) { return recentDb().then(function (db) { return new Promise(function (ok) { var t = db.transaction('files', 'readwrite'); t.objectStore('files').put(rec); t.oncomplete = ok; t.onerror = ok; }); }).catch(function () {}); }
    function recentDel(id) { return recentDb().then(function (db) { return new Promise(function (ok) { var t = db.transaction('files', 'readwrite'); t.objectStore('files').delete(id); t.oncomplete = ok; t.onerror = ok; }); }).catch(function () {}); }
    function makeThumb(blob) {
      return new Promise(function (ok) {
        var im = new Image(), u = URL.createObjectURL(blob);
        im.onload = function () {
          try {
            var k = Math.min(1, 360 / Math.max(im.naturalWidth, im.naturalHeight)), c = document.createElement('canvas');
            c.width = Math.max(1, Math.round(im.naturalWidth * k)); c.height = Math.max(1, Math.round(im.naturalHeight * k));
            c.getContext('2d').drawImage(im, 0, 0, c.width, c.height);
            c.toBlob(function (t) { URL.revokeObjectURL(u); ok(t); }, 'image/png');
          } catch (e) { URL.revokeObjectURL(u); ok(null); }
        };
        im.onerror = function () { URL.revokeObjectURL(u); ok(null); };
        im.src = u;
      });
    }
    function recentId(f) { return (f.name || 'image') + '|' + f.size + '|' + (f.lastModified || 0); }
    function rememberUpload(f) {
      var id = f._mxId || recentId(f);
      makeThumb(f).then(function (t) { return recentPut({ id: id, at: Date.now(), name: f.name || 'image', type: f.type, blob: f, thumb: t }); }).then(function () {
        return recentAll();
      }).then(function (list) {
        var drops = list.slice(RECENT_MAX);
        return Promise.all(drops.map(function (r) { return recentDel(r.id); })).then(function () { drawRecent(list.slice(0, RECENT_MAX), id); });
      });
    }
    function recFile(rec) {
      var f; try { f = new File([rec.blob], rec.name, { type: rec.type || rec.blob.type }); } catch (e) { f = rec.blob; f.name = rec.name; }
      f._mxId = rec.id; return f;
    }
    function drawRecent(list, activeId) {
      if (!recentEl) {
        var block = q('.mv-studio__block'); if (!block) { return; }
        recentEl = document.createElement('div'); recentEl.className = 'mv-recent';
        recentEl.innerHTML = '<p class="mv-recent__head">Recent uploads</p>';
        recentGrid = document.createElement('div'); recentGrid.className = 'mv-recent__grid';
        recentEl.appendChild(recentGrid);
        block.parentNode.insertBefore(recentEl, block.nextSibling);
      }
      recentUrls.forEach(function (u) { URL.revokeObjectURL(u); }); recentUrls = [];
      recentGrid.innerHTML = '';
      recentEl.hidden = !list.length;
      list.forEach(function (rec) {
        var cell = document.createElement('div'); cell.className = 'mv-recent__cell' + (rec.id === activeId ? ' is-on' : '');
        var b = button('mv-recent__pic', '', 'Use ' + rec.name);
        var im = document.createElement('img'); im.alt = ''; im.decoding = 'async'; im.draggable = false;
        var u = URL.createObjectURL(rec.thumb || rec.blob); recentUrls.push(u); im.src = u; b.appendChild(im);
        /* Big files decode slowly, so each gets a small preview the first time it's drawn. */
        if (!rec.thumb) { makeThumb(rec.blob).then(function (t) { if (t) { rec.thumb = t; recentPut(rec); } }); }
        b.draggable = true;
        b.addEventListener('dragstart', function (e) { dragRec = rec; e.dataTransfer.effectAllowed = 'copy'; try { e.dataTransfer.setData('text/plain', rec.name); } catch (er) {} app.classList.add('is-carrying'); });
        b.addEventListener('dragend', function () { dragRec = null; app.classList.remove('is-carrying'); });
        b.addEventListener('click', function () {
          /* Tapped again, or tapped fast across several: each tap used to start its own upload, two came up
             selected and the one left behind said "That didn't reach us" (3 Nov, Kaitlin). The photo already in
             use does nothing, and taps under 700ms apart are one tap. */
          var now = Date.now();
          if (focusBox && focusBox._sheet) { focusBox._sheet.hidden = true; }
          if ((currentFile && currentFile._mxId === rec.id) || now - lastRecTap < 700) { return; }
          lastRecTap = now;
          setFile(recFile(rec));
          /* On a phone the Uploads pane covers the whole screen, so picking one there left them looking at the
             list with nothing to tap (23 Sep, Kaitlin: "when people click like their uploads on mobile do they
             can click create?"). Go back to the templates, the same as choosing a new photo does. */
          if (dockGo && railPane() !== 'create' && (!focusFig || narrow())) { dockGo('create'); }
        });
        var x = button('mv-recent__x', '×', 'Remove ' + rec.name);
        x.addEventListener('click', function (e) {
          e.stopPropagation();
          recentDel(rec.id).then(recentAll).then(function (l) { drawRecent(l, activeId); });
        });
        cell.appendChild(b); cell.appendChild(x); recentGrid.appendChild(cell);
      });
    }
    recentAll().then(function (list) { drawRecent(list, null); });
    /* Side tabs like Canva's (21 Sep, Kaitlin: "make it like a library like how Canva does it, a tab on the left").
       Desktop only: a narrow icon strip left of the rail switches the rail between Create (upload box, view, sort,
       credits), Uploads (recent uploads, big) and Made (this visit's images, big). data-pane on the rail; CSS shows
       the right blocks. It always opens on Create. */
    if (app.classList.contains('mv-studio')) {
      var rail = q('.mv-studio__rail'), panes = [
        ['create', 'Create', '<rect x="4.5" y="4.5" width="15" height="15" rx="1"/><path d="M10 4.5v15M10 11h9.5"/>'],
        /* No Uploads tab (3 Nov, Kaitlin: "remove uploads tab now"). Their uploads still come up beside an open
           mockup, which is the only place they are used: the pane stays, it just has no button. */
        ['made', 'Projects', '<rect x="4.5" y="4.5" width="6.5" height="6.5"/><rect x="13" y="4.5" width="6.5" height="6.5"/><rect x="4.5" y="13" width="6.5" height="6.5"/><rect x="13" y="13" width="6.5" height="6.5"/>']
      ];
      var dock = document.createElement('nav'); dock.className = 'mv-dock'; dock.setAttribute('aria-label', 'Panels');
      var dockBtns = {};
      function markDock(id) {
        Object.keys(dockBtns).forEach(function (k) { dockBtns[k].setAttribute('aria-pressed', k === id ? 'true' : 'false'); });
      }
      dockMark = markDock; dockGo = setPane;
      function setPane(id) {
        rail.setAttribute('data-pane', id);
        markDock(id);
        rail.scrollTop = 0;
        creditsPage(id === 'credits');
        partnerPage(id === 'partner');
        projectsPage(id === 'made' && !narrow());
      }
      /* Credits is a page of its own, on a phone too (3 Nov, Kaitlin: "a new tab called credit", then "make credit
         tab better… a sparkle… things they have exported with progress bar… dopamine good keeping my aesthetic").
         Every number on it is real: the balance from /usage, the bar from the packs signed into their token (live
         ones, 12 months), the counts from what Projects already holds. It is rebuilt each time it opens and the
         numbers count up from nothing, so opening it is the reward. */
      var credBox = null;
      function packTotal() {
        if (bought != null) { return bought; }
        var f = (app.getAttribute('data-token') || '').split('.')[2] || 'n', year = 365 * 86400000;
        if (f === 'n') { return 0; }
        return f.split('_').reduce(function (sum, e) {
          var b = e.split('-'), ts = Number(b[1]) * 1000;
          return sum + (ts && ts + year > Date.now() ? (Number(b[2]) || 0) : 0);
        }, 0);
      }
      function countUp(el, to, dur) {
        var t0 = performance.now();
        (function step(now) {
          var k = Math.min(1, (now - t0) / dur), e = 1 - Math.pow(1 - k, 3);
          el.textContent = Math.round(to * e);
          if (k < 1) { requestAnimationFrame(step); }
        })(t0);
        setTimeout(function () { el.textContent = to; }, dur + 80);
      }
      /* Third pass (3 Nov, Kaitlin: "i don't like milestones or day creating, i liked the progress bar moving…
         refer and get $29 credits… a custom link… i don't like 5 mockups 0 videos, we say templates"). The balance
         card has the bar that fills as the page opens; then their latest work, the top ups, and the refer card. Every
         number is real: the bar is credits left of the credits bought in the last 12 months (/usage `bought`). */
      function esc(t) { return String(t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
      function drawCredits() {
        var bal = lastBal == null ? 0 : lastBal, unl = remaining === Infinity;
        var total = packTotal(), paidLeft = unl ? 0 : Math.max(0, remaining || 0);
        var photosL = made.filter(function (m) { return !m.video && m.state && m.state.url; });
        var canT = Math.floor(bal / NEW), canV = Math.floor(bal / 20);
        var h = '<div class="mv-cred__cols"><div class="mv-cred__col">';
        h += '<div class="mv-cred__card"><p class="mv-cred__label"><span>Credits</span><b>' + (unl ? 'Unlimited' : '<span data-cn="' + bal + '">0</span>') + '</b></p>';
        if (!unl) {
          if (total > 0 && paidLeft <= total) {
            var k = Math.min(1, paidLeft / total);
            h += '<div class="mv-cred__bar" role="img" aria-label="' + paidLeft + ' of ' + total + ' credits left"><i style="--k:' + k.toFixed(3) + '"></i></div>';
          }
          h += '<p class="mv-cred__ruler-note"><span>' + (canT ? '<b data-cn="' + canT + '">0</b> ' + (canT === 1 ? 'template' : 'templates') + (canV ? ' or ' + canV + (canV === 1 ? ' video' : ' videos') : '') + ' left' : 'Top up to make more') + '</span>'
            + (total > 0 && paidLeft <= total ? '<span>' + paidLeft + ' of ' + total + ' left</span>' : '') + '</p>';
        }
        h += '</div>';
        if (packs.length && !unl) {
          h += '<p class="mv-cred__label mv-cred__label--gap"><span>Top up</span><small>Lasts 12 months</small></p><div class="mv-cred__packs">'
            + packs.map(function (p, i) {
              var t = Math.floor(Number(p.credits) / NEW), v = Math.floor(Number(p.credits) / 20);
              return '<a class="mv-cred__pack' + (i === 1 ? ' is-pick' : '') + '" href="/cart/' + p.variant + ':1"><span><b>+' + p.credits + '</b> credits' + (i === 1 ? '<em>Most picked</em>' : '') + '</span><small>' + t + ' templates or ' + v + (v === 1 ? ' video' : ' videos') + '</small><strong>' + p.price + '</strong></a>';
            }).join('') + '</div>';
        }
        h += '</div><div class="mv-cred__col">';
        /* refer a friend */
        h += '<div class="mv-cred__refer" data-refer><p class="mv-cred__label"><span>Refer a friend</span><small data-ref-earned></small></p>'
          + '<p class="mv-cred__refer-line">Send a friend your link. When they top up, you get <b>' + REF_CREDITS + ' credits</b>, worth $29.</p>'
          + '<div class="mv-cred__link"><input type="text" readonly aria-label="Your link" data-ref-link value="Making your link…"><button type="button" data-ref-copy disabled>Copy</button></div>'
          + '<p class="mv-cred__refer-note" data-ref-note></p></div>';
        var sheet = photosL.slice(0, 8);
        if (sheet.length) {
          h += '<p class="mv-cred__label mv-cred__label--gap"><span>Latest</span></p><div class="mv-cred__sheet">' + sheet.map(function (m, i) {
            var nm = (m.item.n || 'template').toUpperCase().replace(/[^A-Z0-9]+/g, '_').replace(/^_|_$/g, '').slice(0, 18);
            return '<figure style="--i:' + i + '" data-k="' + i + '"><span><img src="' + esc(m.state.url) + '" alt="" loading="lazy"></span><figcaption>' + esc(nm) + '.JPG</figcaption></figure>';
          }).join('') + '</div>';
        }
        var tally = {};
        photosL.forEach(function (m) { var u = m.item.u; tally[u] = tally[u] || { it: m.item, n: 0 }; tally[u].n++; });
        var top = Object.keys(tally).map(function (u) { return tally[u]; }).sort(function (x, y) { return y.n - x.n; })[0];
        if (top && top.n > 1) {
          h += '<p class="mv-cred__label mv-cred__label--gap"><span>Your go-to</span></p><button type="button" class="mv-cred__goto" data-goto>'
            + '<span class="mv-cred__goto-pic"><img src="' + esc(top.it.b && inspoBase ? assetUrl('me-blank-' + top.it.u + '.jpg') : top.it.lt && inspoBase ? assetUrl('me-thumb-' + top.it.u + '.jpg') : thumb(top.it.t)) + '" alt=""></span><span class="mv-cred__goto-name">' + esc(top.it.n) + '</span><span class="mv-cred__goto-n">×' + top.n + '</span></button>';
        }
        h += '</div></div>';
        credBox.innerHTML = h;
        Array.prototype.forEach.call(credBox.querySelectorAll('[data-cn]'), function (el) { countUp(el, Number(el.getAttribute('data-cn')) || 0, 900); });
        Array.prototype.forEach.call(credBox.querySelectorAll('.mv-cred__sheet figure'), function (f) {
          f.addEventListener('click', function () { var m = sheet[Number(f.getAttribute('data-k'))]; if (m) { openProject(m); } });
        });
        var go = credBox.querySelector('[data-goto]');
        if (go) { go.addEventListener('click', function () { var hit = made.filter(function (m) { return m.item === top.it && m.state && m.state.url; })[0]; if (hit) { openProject(hit); } }); }
        drawRefer();
        requestAnimationFrame(function () { requestAnimationFrame(function () { credBox.classList.add('is-in'); }); });
      }
      /* The link is made by the worker on first ask (GET /ref) and kept: the same code forever. */
      var REF_CREDITS = 30, refInfo = null;
      function drawRefer() {
        var box = credBox.querySelector('[data-refer]');
        if (!box) { return; }
        var input = box.querySelector('[data-ref-link]'), copy = box.querySelector('[data-ref-copy]'), note = box.querySelector('[data-ref-note]'), earned = box.querySelector('[data-ref-earned]');
        function fill(r) {
          input.value = r.link; copy.disabled = false;
          if (r.earned) { earned.textContent = '+' + r.earned + ' earned'; }
          note.textContent = r.joined ? r.joined + (r.joined === 1 ? ' friend joined' : ' friends joined') + (r.paid ? ', ' + r.paid + ' topped up' : '') + '.' : '';
        }
        copy.addEventListener('click', function () {
          var link = input.value;
          var done = function () { copy.textContent = 'Copied'; setTimeout(function () { copy.textContent = 'Copy'; }, 1600); };
          if (navigator.share && narrow()) { navigator.share({ title: 'Mock Exchange', text: 'Put your logo on real photos.', url: link }).catch(function () {}); return; }
          if (navigator.clipboard) { navigator.clipboard.writeText(link).then(done, function () { input.select(); }); } else { input.select(); document.execCommand('copy'); done(); }
        });
        if (narrow() && navigator.share) { copy.textContent = 'Share'; }
        if (refInfo) { fill(refInfo); }
        fetch(endpoint + '/ref?token=' + encodeURIComponent(token)).then(function (r) { return r.json(); })
          .then(function (r) { if (r && r.link) { refInfo = r; if (box.isConnected) { fill(r); } } else if (box.isConnected) { input.value = 'Couldn’t make your link. Try again soon.'; } })
          .catch(function () { if (box.isConnected && !refInfo) { input.value = 'Couldn’t make your link. Try again soon.'; } });
      }
      function creditsPage(on) {
        if (!scroller) { return; }
        if (on) {
          if (!credBox) {
            credBox = document.createElement('section'); credBox.className = 'mv-credits';
            scroller.insertBefore(credBox, scroller.firstChild);
          }
          credBox.classList.remove('is-in');
          drawCredits();
          credBox.hidden = false; app.classList.add('is-credits');
          scroller.scrollTop = 0;
        } else if (credBox && app.classList.contains('is-credits')) {
          credBox.hidden = true; app.classList.remove('is-credits');
        }
      }
      /* Partners (3 Nov, Kaitlin: "add a new tab, partner… are you a content creator… for every photo uploaded and
         used you get credits back, we will notify you by email… T&Cs… make it SUPER exclusive looking"). A black
         invitation card, what we look for, the upload, the terms. Photos go to the worker's /partner (R2); we look
         at them by hand and give PARTNER_CREDITS for each one used, so nothing on this page is automatic. */
      var partBox = null, PARTNER_CREDITS = 30;
      function partnerPage(on) {
        if (!scroller) { return; }
        if (on) {
          if (!partBox) {
            partBox = document.createElement('section'); partBox.className = 'mv-partner';
            scroller.insertBefore(partBox, scroller.firstChild);
            drawPartner();
          }
          partBox.classList.remove('is-in');
          partBox.hidden = false; app.classList.add('is-partner');
          scroller.scrollTop = 0;
          requestAnimationFrame(function () { requestAnimationFrame(function () { partBox.classList.add('is-in'); }); });
        } else if (partBox && app.classList.contains('is-partner')) {
          partBox.hidden = true; app.classList.remove('is-partner');
        }
      }
      function drawPartner() {
        var email = app.getAttribute('data-email') || '';
        /* Simpler, like the rest of the studio (3 Nov, Kaitlin: "i hate the big black box… make it more like rest of
           my website", "dont bother the DPI thing, doesnt need to be blank either") */
        partBox.innerHTML = '<div class="mv-part__cols"><div>'
          + '<p class="mv-cred__label"><span>Partners</span></p>'
          + '<p class="mv-part__title">Are you a content creator?</p>'
          /* No rules to meet (3 Nov, Kaitlin: "no need for good light or clean… we can work magic on photos… I don't
             want people thinking they can create templates… send it to our workshop") */
          + '<p class="mv-part__lede">Send your photos to our workshop. If it’s aesthetic, we can probably make something of it. We work on every photo by hand and turn the best into templates.</p>'
          + '<p class="mv-part__lede">For each one we use, you get ' + PARTNER_CREDITS + ' credits, and we’ll let you know by email.</p>'
          + '</div><div>'
          + '<p class="mv-cred__label"><span>Send to the workshop</span></p>'
          + '<form class="mv-part__form" data-part-form novalidate>'
          + '<label class="mv-part__drop" data-part-drop><input type="file" accept="image/jpeg,image/png,image/webp,image/heic,image/heif,image/tiff" multiple data-part-files><span data-part-pick>Choose photos</span></label>'
          + '<div class="mv-part__thumbs" data-part-thumbs></div>'
          + '<label class="mv-part__field"><span>Email</span><input type="email" name="email" value="' + esc(email) + '" required></label>'
          + '<label class="mv-part__field"><span>Instagram</span><input type="text" name="ig" placeholder="@yourname" autocomplete="off"></label>'
          + '<label class="mv-part__agree"><input type="checkbox" name="agree"><span>I took these photos and I agree to the Partner terms.</span></label>'
          + '<button type="submit" class="mv-part__send" data-part-send disabled>Send photos</button>'
          + '<div class="mv-part__bar" hidden data-part-bar><i></i></div>'
          + '<p class="mv-part__note" data-part-note></p>'
          + '</form>'
          + '<details class="mv-part__terms"><summary>Partner terms</summary><ol>'
          + '<li>You took every photo you send and you own it. No AI images, no stock, nothing that belongs to someone else.</li>'
          + '<li>Sending a photo is not a sale. We choose which photos become templates. If we don’t use one, we delete it within 90 days.</li>'
          + '<li>For each photo we turn into a template you get ' + PARTNER_CREDITS + ' credits, once, added to this account. We email you when it goes live. Credits work like a top up, last 12 months and can’t be swapped for cash.</li>'
          + '<li>For a photo we use, you give Mock Exchange a worldwide, non-exclusive licence for good to edit it, turn it into a template and offer it in the studio. You keep the copyright and can keep using the photo yourself.</li>'
          + '<li>We may crop, retouch, recolour and rename it. We don’t have to credit you by name, but we may ask to.</li>'
          + '<li>You need to be 18 or over.</li>'
          + '<li>We can change or end the programme at any time. Credits you have already earned stay yours.</li>'
          + '</ol></details>'
          + '</div></div>';
        var form = partBox.querySelector('[data-part-form]'), input = form.querySelector('[data-part-files]'), thumbs = form.querySelector('[data-part-thumbs]');
        var send = form.querySelector('[data-part-send]'), note = form.querySelector('[data-part-note]'), bar = form.querySelector('[data-part-bar]'), pick = form.querySelector('[data-part-pick]');
        var files = [], busy = false;
        function ready() { send.disabled = busy || !files.length || !form.agree.checked || !/.+@.+\..+/.test(form.email.value); }
        function show() {
          thumbs.innerHTML = '';
          files.forEach(function (f, i) {
            var c = document.createElement('span'); c.className = 'mv-part__thumb';
            var im = document.createElement('img'); im.alt = ''; im.src = URL.createObjectURL(f); im.onload = function () { URL.revokeObjectURL(im.src); };
            var x = document.createElement('button'); x.type = 'button'; x.textContent = '×'; x.setAttribute('aria-label', 'Remove');
            x.addEventListener('click', function () { files.splice(i, 1); show(); });
            c.appendChild(im); c.appendChild(x); thumbs.appendChild(c);
          });
          pick.textContent = files.length ? files.length + (files.length === 1 ? ' photo' : ' photos') + ' · add more' : 'Choose photos';
          ready();
        }
        function add(list) {
          Array.prototype.forEach.call(list || [], function (f) { if (/^image\//.test(f.type)) { files.push(f); } });
          note.textContent = ''; show();
        }
        input.addEventListener('change', function () { add(input.files); input.value = ''; });
        var drop = form.querySelector('[data-part-drop]');
        drop.addEventListener('dragover', function (e) { e.preventDefault(); drop.classList.add('is-over'); });
        drop.addEventListener('dragleave', function () { drop.classList.remove('is-over'); });
        drop.addEventListener('drop', function (e) { e.preventDefault(); e.stopPropagation(); drop.classList.remove('is-over'); add(e.dataTransfer && e.dataTransfer.files); });
        form.addEventListener('input', ready); form.addEventListener('change', ready);
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          if (send.disabled) { return; }
          busy = true; ready(); bar.hidden = false; bar.firstChild.style.width = '0%';
          var batch = Date.now().toString(36) + Math.random().toString(36).slice(2, 8), done = 0, list = files.slice();
          var em = form.email.value.trim(), ig = form.ig.value.trim();
          send.textContent = 'Sending 1 of ' + list.length;
          list.reduce(function (p, f, i) {
            return p.then(function () {
              var b = new FormData();
              b.append('token', token); b.append('batch', batch); b.append('n', String(i + 1)); b.append('email', em); b.append('ig', ig); b.append('file', f, f.name);
              return fetch(endpoint + '/partner', { method: 'POST', body: b }).then(function (r) {
                return r.json().catch(function () { return {}; }).then(function (j) { if (!r.ok) { throw new Error(j.error || 'That didn’t send. Try again.'); } });
              }).then(function () {
                done++; bar.firstChild.style.width = Math.round(done / list.length * 100) + '%';
                if (done < list.length) { send.textContent = 'Sending ' + (done + 1) + ' of ' + list.length; }
              });
            });
          }, Promise.resolve()).then(function () {
            /* a line in the store inbox, so we know to look */
            var shop = new FormData();
            shop.append('form_type', 'contact'); shop.append('utf8', '✓');
            shop.append('contact[name]', 'Partner photos'); shop.append('contact[email]', em);
            shop.append('contact[body]', list.length + (list.length === 1 ? ' photo' : ' photos') + ' sent to Partners (batch ' + batch + ')' + (ig ? ', Instagram ' + ig : '') + '.');
            fetch('/contact', { method: 'POST', body: shop, credentials: 'same-origin' }).catch(function () {});
            files = []; show();
            note.textContent = 'Thank you. We’ll email ' + em + ' if we use one.';
            if (window.mxTrack) { window.mxTrack('partner_send'); }
          }, function (err) {
            files = files.slice(done); show();
            note.textContent = (offline(err) ? 'That didn’t reach us. Check your connection and try again.' : err.message) + (done ? ' ' + done + ' sent already.' : '');
          }).then(function () { busy = false; send.textContent = 'Send photos'; bar.hidden = true; ready(); });
        });
      }
      /* Projects is a page, not the narrow panel (3 Nov, Kaitlin: "projects isnt still in that weird skinny thing
         right?"). On a computer the tray moves into the main area as a full grid, like Canva's Projects, and the
         panel steps aside; anything else puts it back. Phones already show the panel full screen. */
      var projBox = null, trayHome = null, trayNext = null;
      function projectsPage(on) {
        if (!tray || !scroller) { return; }
        if (on) {
          if (!projBox) {
            projBox = document.createElement('section'); projBox.className = 'mv-projects';
            projBox.innerHTML = '<p class="mv-projects__title">Projects</p><p class="mv-projects__empty">Mockups and videos you make show here.</p>';
            scroller.insertBefore(projBox, scroller.firstChild);
          }
          if (tray.parentNode !== projBox) { trayHome = tray.parentNode; trayNext = tray.nextSibling; projBox.appendChild(tray); }
          projBox.hidden = false; app.classList.add('is-projects');
          scroller.scrollTop = 0;
        } else if (projBox && app.classList.contains('is-projects')) {
          if (trayHome) { trayHome.insertBefore(tray, trayNext && trayNext.parentNode === trayHome ? trayNext : null); }
          projBox.hidden = true; app.classList.remove('is-projects');
        }
      }
      function dockIcon(path, label) {
        return button('mv-dock__btn', '<svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">' + path + '</svg><span>' + label + '</span>', label);
      }
      panes.forEach(function (p) {
        var b = dockIcon(p[2], p[1]);
        b.className += ' mv-dock__btn--' + p[0];
        b.addEventListener('click', function () {
          /* Create means start something new, so coming out of Mine puts the whole library back
             (6 Oct, Kaitlin: "when they are in mine and then click CREATE it should go back to ALL"). */
          if (p[0] === 'create' && cats[current] && cats[current].owned) { setCategory(allIndex()); }
          setPane(p[0]);
        });
        dockBtns[p[0]] = b; dock.appendChild(b);
        /* No round + on the phone bar any more (3 Nov, Kaitlin: "not needed now"): a photo is added beside the
           mockup they open. */
      });
      /* Templates they have paid for (23 Sep, Kaitlin: "a tab that says my templates… purchased… i want it to be
         short"). Not a rail panel: it shows the library filtered to theirs, so it works the same on a phone and a
         computer. On phones it takes Home's place in the tab bar and the logo at the top goes home instead. */
      if (!guest) {
        /* An open padlock (23 Sep, Kaitlin): these are the templates that are no longer locked to them. */
        var mine = dockIcon('<rect x="5" y="11" width="14" height="9" rx="1.5"/><path d="M8.5 11V8a3.5 3.5 0 0 1 6.8-1.2"/>', 'Mine');
        mine.className += ' mv-dock__mine';
        mine.addEventListener('click', function () {
          var vt = document.querySelector('[data-lib-tab="photo"]');
          if (vt && vt.getAttribute('aria-selected') !== 'true') { vt.click(); }
          setPane('create');
          if (mineChip) { mineChip.click(); }
          markDock('mine');
          if (scroller) { scroller.scrollTop = 0; }
        });
        dockBtns.mine = mine; dock.appendChild(mine);
        /* A sparkle, under Mine (3 Nov, Kaitlin: "i dont like that icon… maybe under mine… make it a sparkle"). */
        var cred = dockIcon('<path d="M11 4c.7 4.6 2.1 6.3 6.5 7-4.4.7-5.8 2.4-6.5 7-.7-4.6-2.1-6.3-6.5-7 4.4-.7 5.8-2.4 6.5-7z"/><path d="M18 3.5v4M16 5.5h4"/>', 'Credits');
        cred.className += ' mv-dock__btn--credits';
        cred.addEventListener('click', function () {
          if (cats[current] && cats[current].owned) { setCategory(allIndex()); }
          /* phones keep their slim top bar: the page opens over the library, the rail stays on Create */
          if (narrow()) { setPane('create'); creditsPage(true); markDock('credits'); return; }
          setPane('credits');
        });
        dockBtns.credits = cred; dock.appendChild(cred);
        /* A heart: Partners, after Credits (3 Nov, Kaitlin: "partner - heart, mine - unlocked thing") */
        var part = dockIcon('<path d="M12 19.5s-7-4.3-8.6-8.4C2.3 8.2 4.1 5 7.3 5c1.9 0 3.4 1.1 4.7 2.8C13.3 6.1 14.8 5 16.7 5c3.2 0 5 3.2 3.9 6.1C19 15.2 12 19.5 12 19.5z"/>', 'Partner');
        part.className += ' mv-dock__btn--partner';
        part.addEventListener('click', function () {
          if (cats[current] && cats[current].owned) { setCategory(allIndex()); }
          if (narrow()) { setPane('create'); partnerPage(true); markDock('partner'); return; }
          setPane('partner');
        });
        dockBtns.partner = part; dock.appendChild(part);
      }
      var home = document.createElement('a'); home.className = 'mv-dock__btn mv-dock__home'; home.href = '/';
      home.innerHTML = '<svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M4.5 10.5 12 4.5l7.5 6V19.5h-5v-5h-5v5h-5z"/></svg><span>Home</span>';
      dock.appendChild(home);
      app.insertBefore(dock, rail);
      /* Logo top right, on the Photo | Video row (21 Sep, Kaitlin). */
      var folder = q('.mv-folder');
      if (folder) { var tl = document.createElement('a'); tl.className = 'mv-toplogo'; tl.href = '/'; tl.textContent = 'Mock Exchange'; tl.setAttribute('aria-label', 'Mock Exchange home'); folder.appendChild(tl); }
      /* Pane heads and empty notes */
      var upHead = document.createElement('div'); upHead.className = 'mv-pane mv-pane--uploads';
      upHead.innerHTML = '<p class="mv-pane__title">Uploads</p>';
      var upBtn = button('mv-pane__btn', '+ Upload photo'); upBtn.addEventListener('click', function () { fileInput.click(); });
      upHead.appendChild(upBtn);
      upHead.appendChild(Object.assign(document.createElement('p'), { className: 'mv-pane__empty mv-pane__empty--uploads', textContent: 'Photos you upload show here, ready to use again.' }));
      var madeHead = document.createElement('div'); madeHead.className = 'mv-pane mv-pane--made';
      madeHead.innerHTML = '<p class="mv-pane__title">Projects</p><p class="mv-pane__empty mv-pane__empty--made">Mockups and videos you make show here.</p>';
      /* The "See all your mockups" link is gone: the Owned tab does that now (23 Sep). */
      var logo = q('.mv-studio__logo');
      rail.insertBefore(madeHead, logo.nextSibling); rail.insertBefore(upHead, logo.nextSibling);
      /* always Create, never the pane they left on: landing in Made meant an empty screen and no way to see
         it was a pane (Kaitlin, 25 Sep: "it should go to create") */
      setPane('create');
      /* A new upload from the Uploads pane: back to Create so they see it in place. */
      fileInput.addEventListener('change', function () { if (rail.getAttribute('data-pane') !== 'create' && (!focusFig || narrow())) { setPane('create'); } });
    }
    /* A logo dropped on the home page before signing up (me-try.js). Taken once, only if it's under an hour old. */
    function takePending() {
      try {
        var raw = localStorage.getItem('mx-try');
        if (!raw) { return null; }
        localStorage.removeItem('mx-try');
        var p = JSON.parse(raw);
        if (!p || !p.d || Date.now() - (p.at || 0) > 3600000) { return null; }
        var parts = p.d.split(','), bin = atob(parts[1]), bytes = new Uint8Array(bin.length);
        for (var i = 0; i < bin.length; i++) { bytes[i] = bin.charCodeAt(i); }
        var type = (parts[0].match(/data:([^;]+)/) || [])[1] || 'image/png';
        return new File([bytes], p.n || 'your-logo.png', { type: type });
      } catch (e) { return null; }
    }
    var pendingFile = takePending();
    /* Remove the current image (21 Sep, Kaitlin: "how do I get rid of the image, it just stays there"). A small ×
       on the preview puts the drop box back to empty. It stays in Recent uploads. */
    function clearFile() {
      art = null; currentFile = null; uploading = null; queued = null; resetMade();
      preview.removeAttribute('src'); nameEl.textContent = ''; fileInput.value = '';
      empty.hidden = false; full.hidden = true; drop.classList.remove('has-file');
      app.classList.remove('has-art'); refreshCtas();
      hint.textContent = ''; hideError(); step(1);
      if (recentGrid) { Array.prototype.forEach.call(recentGrid.children, function (c) { c.classList.remove('is-on'); }); }
    }
    var clearBtn = button('mv-lib__clear', '×', 'Remove this image');
    clearBtn.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); clearFile(); });
    full.appendChild(clearBtn);
    var pendingLoaded = pendingFile ? setFile(pendingFile) : null;
    fileInput.addEventListener('change', function () { setFile(fileInput.files[0]); });
    fileInput.addEventListener('cancel', function () { queued = null; });

    /* Their last image, kept in this browser (localStorage mx-logo, 60 days, downscaled): offered on the next visit.
       Paste (Cmd+V) and dropping a file anywhere on the studio work too. (UX pass, 19 Sep.) */
    var again = q('[data-lib-again]');
    /* Keep their file in this browser: mx-logo is the "use it again" one, mx-try is the one the studio picks up and
       makes straight away (me-try.js writes the same thing from the home page). */
    function keep(key, f) {
      var im = new Image();
      im.onload = function () {
        var sizes = [1400, 900, 600], type = f.type === 'image/jpeg' ? 'image/jpeg' : 'image/png';
        for (var i = 0; i < sizes.length; i++) {
          try {
            var k = Math.min(1, sizes[i] / Math.max(im.naturalWidth, im.naturalHeight)), c = document.createElement('canvas');
            c.width = Math.round(im.naturalWidth * k); c.height = Math.round(im.naturalHeight * k);
            c.getContext('2d').drawImage(im, 0, 0, c.width, c.height);
            localStorage.setItem(key, JSON.stringify({ d: c.toDataURL(type, 0.9), n: f.name, at: Date.now() }));
            return;
          } catch (e) { /* too big or no storage */ }
        }
      };
      im.src = URL.createObjectURL(f);
    }
    /* The sign-up pop-up does this job now (23 Sep): no message and button squeezed into the top bar. */
    /* The account comes after they have seen their image. Their logo goes with them, so it is made again, full size
       and free, the second they are in. */
    function askSignUp(photo) {
      if (currentFile) { keep('mx-try', currentFile); }
      mark('signup_open');
      var next = '/pages/creator-studio';
      var words = photo
        /* Shopify's own sheet has no subscribe box, so this says what happens NEXT rather than pretending it's here
           (23 Sep, Kaitlin: "where does this say subscribe tho"). The list is joined in the studio, one tap. */
        ? { heading: 'Save your image.', sub: 'Make a free account and it is yours, full size. You will get our emails, and can leave any time.', photo: photo }
        : { heading: 'Make an account to keep going.', sub: 'It’s free, and your first mockup is on us. You will get our emails, and can leave any time.', photo: guestMade || null };
      if (!window.mxSignIn || !window.mxSignIn(next, words)) {
        location.href = '/customer_authentication/login?return_to=' + encodeURIComponent(next);
      }
    }
    function lastImage() {
      try {
        var p = JSON.parse(localStorage.getItem('mx-logo') || 'null');
        if (!p || !p.d || Date.now() - (p.at || 0) > 60 * 86400000) { return null; }
        var parts = p.d.split(','), bin = atob(parts[1]), bytes = new Uint8Array(bin.length);
        for (var i = 0; i < bin.length; i++) { bytes[i] = bin.charCodeAt(i); }
        return { url: p.d, file: new File([bytes], p.n || 'your-logo.png', { type: (parts[0].match(/data:([^;]+)/) || [])[1] || 'image/png' }) };
      } catch (e) { return null; }
    }
    var last = !pendingFile && again ? lastImage() : null;
    if (last) {
      q('[data-lib-again-img]').src = last.url; again.hidden = false;
      q('[data-lib-again-use]').addEventListener('click', function () { setFile(last.file); });
    }
    document.addEventListener('paste', function (e) {
      var items = (e.clipboardData && e.clipboardData.files) || [];
      if (items[0] && /^image\//.test(items[0].type)) { e.preventDefault(); setFile(items[0]); }
    });
    ['dragenter', 'dragover'].forEach(function (ev) {
      document.addEventListener(ev, function (e) { if (e.dataTransfer && Array.prototype.indexOf.call(e.dataTransfer.types || [], 'Files') > -1) { e.preventDefault(); app.classList.add('is-dragging'); } });
    });
    document.addEventListener('dragleave', function (e) { if (!e.relatedTarget) { app.classList.remove('is-dragging'); } });
    document.addEventListener('drop', function (e) {
      app.classList.remove('is-dragging');
      if (e.defaultPrevented) { return; }
      if (e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files[0]) { e.preventDefault(); setFile(e.dataTransfer.files[0]); }
    });
    /* The guide's own button and drop area do the same as the rail's drop box. */
    var pickBtn = q('[data-lib-pick]');
    if (pickBtn) { pickBtn.addEventListener('click', function () { fileInput.click(); }); }
    if (guide) {
      ['dragenter', 'dragover'].forEach(function (ev) { guide.addEventListener(ev, function (e) { e.preventDefault(); guide.classList.add('is-over'); }); });
      ['dragleave', 'drop'].forEach(function (ev) { guide.addEventListener(ev, function (e) { e.preventDefault(); guide.classList.remove('is-over'); }); });
      guide.addEventListener('drop', function (e) { if (e.dataTransfer && e.dataTransfer.files[0]) { setFile(e.dataTransfer.files[0]); } });
    }
    ['dragenter', 'dragover'].forEach(function (ev) { drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.add('is-over'); }); });
    ['dragleave', 'drop'].forEach(function (ev) { drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.remove('is-over'); }); });
    drop.addEventListener('drop', function (e) { if (e.dataTransfer && e.dataTransfer.files[0]) { setFile(e.dataTransfer.files[0]); } });

    /* ---- "Your images" tray ---- */
    /* Saved videos (me-video.js hands their cells over) go in the same grid as the photos, newest first. */
    document.addEventListener('mx:made', function () { drawTray(); });
    /* photos and videos both, so not "Your images" */
    if (trayCount && trayCount.previousSibling && trayCount.previousSibling.nodeType === 3) { trayCount.previousSibling.nodeValue = 'All '; }
    function drawTray() {
      var vids = window.mxMadeVideos || [], now = Date.now();
      made.forEach(function (m) { if (!m.at) { m.at = now; } });
      var rows = made.map(function (m) { return { at: m.at, m: m }; }).concat(vids.map(function (c) { return { at: c._at, cell: c }; }));
      rows.sort(function (x, y) { return y.at - x.at; });
      tray.hidden = !rows.length;
      trayCount.textContent = rows.length;
      trayGrid.innerHTML = '';
      rows.forEach(function (row) {
        if (row.cell) { trayGrid.appendChild(row.cell); return; }
        var m = row.m;
        if (m.video) {
          var vb = button('mv-studio__tray-item mv-studio__tray-video', '<video src="' + m.video + '" muted loop autoplay playsinline></video><span>Video</span>', 'Download the ' + m.item.n + ' video');
          vb.addEventListener('click', function () { fetch(m.video).then(function (r) { return r.blob(); }).then(function (b) { saveBlob(b, m.name); }); });
          trayGrid.appendChild(vb);
          return;
        }
        /* A project card: the mockup, its name, when it was last changed. Tapping it opens it to keep editing;
           Download lives there, beside Adjust. */
        var b = button('mv-studio__tray-item mv-proj', '<span class="mv-proj__pic"><img alt="" loading="lazy" src="' + m.state.url + '"></span><span class="mv-proj__name"></span><span class="mv-proj__when">' + ago(m.at) + '</span>', 'Open ' + m.item.n);
        b.querySelector('.mv-proj__name').textContent = m.item.n;
        /* Dynamic Mockups' export links die after 24 hours, so an older make can't be shown. Drop it rather than
           leave a broken square in the tray (23 Sep). */
        b.querySelector('img').addEventListener('error', function () { made = made.filter(function (x) { return x !== m; }); drawTray(); });
        b.addEventListener('click', function () { openProject(m); });
        trayGrid.appendChild(b);
      });
    }
    /* Changing a project moves it to the top, and a reopened older one replaces its old card. */
    function addToTray(entry) {
      entry.at = Date.now();
      made = made.filter(function (x) { return x === entry || !(x.item === entry.item && x.state && entry.state && x.state.art && x.state.art === entry.state.art); });
      if (made.indexOf(entry) === -1) { made.unshift(entry); }
      drawTray();
    }
    function ago(t) {
      var m = Math.round((Date.now() - (t || 0)) / 60000);
      if (m < 2) { return 'just now'; } if (m < 60) { return m + ' min ago'; }
      var h = Math.round(m / 60); if (h < 24) { return h + (h === 1 ? ' hour ago' : ' hours ago'); }
      var d = Math.round(h / 24); return d + (d === 1 ? ' day ago' : ' days ago');
    }
    zipBtn.addEventListener('click', function () {
      if (!made.length) { return; }
      zipBtn.disabled = true; zipBtn.textContent = 'Zipping…';
      var names = {};
      var files = made.map(function (m) {
        if (m.video) { return { url: m.video, name: m.name }; }
        var name = fileName(m.item);
        if (names[name]) { names[name]++; name = name.replace('.jpg', '-' + names[name] + '.jpg'); } else { names[name] = 1; }
        return { url: m.state.url, name: name };
      });
      var done = function () { zipBtn.disabled = false; zipBtn.textContent = 'Download all'; };
      if (!window.JSZip) {
        files.reduce(function (p, f) { return p.then(function () { return fetch(f.url).then(function (r) { return r.blob(); }).then(function (b) { saveBlob(b, f.name); }); }); }, Promise.resolve()).then(done, done);
        return;
      }
      var zip = new window.JSZip();
      Promise.all(files.map(function (f) { return fetch(f.url).then(function (r) { return r.blob(); }).then(function (b) { zip.file(f.name, b); }); }))
        .then(function () { return zip.generateAsync({ type: 'blob' }); })
        .then(function (blob) { saveBlob(blob, 'mock-exchange-images.zip'); })
        .catch(function () { showError('Could not zip them. Download each one instead.'); })
        .then(done);
    });

    /* ---- tiles ---- */
    function tile(item, n) {
      var fig = document.createElement('figure');
      fig.className = 'mv-lib__tile';
      fig.style.setProperty('--i', n % BATCH);
      var img = document.createElement('img'); img.alt = item.n; img.loading = 'lazy'; img.decoding = 'async';
      /* Where the design lands (item.a, traced from a magenta render by dm/15-trace-areas.py): on hover a pink line
         runs round it instead of the "Your logo goes here" pill. Points are on a 0-1000 grid, stretched over the photo. */
      var area = null;
      if (item.a) {
        var SVGNS = 'http://www.w3.org/2000/svg';
        area = document.createElementNS(SVGNS, 'svg'); area.setAttribute('class', 'mv-lib__area'); area.setAttribute('aria-hidden', 'true');
        area.setAttribute('viewBox', '0 0 1000 1000'); area.setAttribute('preserveAspectRatio', 'none');
        fig.classList.add('has-area');
        item.a.forEach(function (pts) {
          ['mv-lib__area-fill', 'mv-lib__area-run'].forEach(function (cls) {
            var p = document.createElementNS(SVGNS, 'polygon'); p.setAttribute('class', cls); p.setAttribute('points', pts);
            p.setAttribute('pathLength', '100'); p.setAttribute('vector-effect', 'non-scaling-stroke');
            area.appendChild(p);
          });
        });
      }
      img.addEventListener('load', function () {
        fig.classList.add('is-loaded');
        /* tell its column how tall it really is (see place()) */
        var real = img.naturalWidth ? img.naturalHeight / img.naturalWidth : EST;
        if (fig._col) { fig._col._h += real - fig._est; }
        fig._est = real;
      });
      /* "b": our own blank render instead of Dynamic Mockups' thumbnail, so the scans show Kaitlin's greige bed
         (20 Sep), the same colour the video editor and their finished renders use. dm/17-scan-blanks.mjs.
         "lt": the thumbnail copied onto our own CDN (21 Sep, after S3 hung and the library went blank:
         dm/18-local-thumbs.mjs). If ours fails, the worker's /img, then S3 itself. And whatever happens, the tile
         shows after 4 seconds, so the library can never sit blank again. */
      var tries = [];
      if (item.b && inspoBase) { tries.push(assetUrl('me-blank-' + item.u + '.jpg')); }
      if (item.lt && inspoBase) { tries.push(assetUrl('me-thumb-' + item.u + '.jpg')); }
      if (item.t) { tries.push(thumb(item.t), item.t); }
      img.addEventListener('error', function () { if (tries.length) { img.src = tries.shift(); } else { fig.classList.add('is-loaded', 'is-noimg'); } });
      setTimeout(function () { fig.classList.add('is-loaded'); }, 4000);
      img.src = tries.shift();
      if (item.f && inspoBase) {
        var eg = document.createElement('img'); eg.className = 'mv-lib__inspo'; eg.alt = ''; eg.decoding = 'async'; eg._src = inspoSrc(item);
        eg.addEventListener('load', function () { fig.classList.add('has-inspo'); });
        fig._inspo = eg;
        if (inspoOn) { loadInspo(fig); }
      }
      var cta = document.createElement('span'); cta.className = 'mv-lib__cta'; cta.innerHTML = 'Use this template <small>' + (ownedFree(item) ? 'Free' : NEW + ' credits') + '</small>';
      /* Product-card tiles (21 Sep, Kaitlin's inspo: catalogue grids with 01 / 02, name left and price right, on soft
         grey cards). The photo and everything drawn over it (area outline, CTA, example, tools) live in .mv-lib__shot
         so they line up with the image; the number, tag, name and cost sit around it. */
      var shot = document.createElement('div'); shot.className = 'mv-lib__shot'; fig._shot = shot;
      var head = document.createElement('div'); head.className = 'mv-lib__head';
      var num = document.createElement('span'); num.className = 'mv-lib__num'; num.textContent = String(n + 1).padStart(2, '0');
      head.appendChild(num);
      var cap = document.createElement('figcaption');
      var capName = document.createElement('span'); capName.className = 'mv-lib__name'; capName.textContent = item.n;
      var capCost = document.createElement('span'); capCost.className = 'mv-lib__cost'; capCost.textContent = ownedFree(item) ? 'Free' : '';
      cap.appendChild(capName); cap.appendChild(capCost); fig._cost = capCost;
      shot.appendChild(img); if (fig._inspo) { shot.appendChild(fig._inspo); shot.appendChild(Object.assign(document.createElement('span'), { className: 'mv-lib__eg', textContent: 'Example' })); }
      if (area) { shot.appendChild(area); } shot.appendChild(cta);
      fig.appendChild(head); fig.appendChild(shot); fig.appendChild(cap);
      if (isOwned(item)) { fig.classList.add('is-owned'); }
      /* No tags on the tiles (3 Nov, Kaitlin: "remove all the tags like spreads across, recolour etc"). Yours went too:
         the Mine tab and "Free" under the photo already say it. */
      /* Hearts are saved in this browser, so they're only offered to someone with an account to come back to
         (23 Sep, Kaitlin: "turn off favourites unless they have account"). Credits have nothing to do with it:
         a customer with none can still save what they like. */
      var heart = guest ? null : button('mv-lib__heart', '<svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true"><path d="M12 20.5s-7.5-4.6-9.3-9.2C1.5 8.2 3.4 4.5 7 4.5c2.1 0 3.6 1.2 5 3 1.4-1.8 2.9-3 5-3 3.6 0 5.5 3.7 4.3 6.8-1.8 4.6-9.3 9.2-9.3 9.2z"/></svg>', 'Save ' + item.n);
      if (heart) {
      var paintHeart = function () { var on = !!hearts[item.u]; heart.classList.toggle('is-on', on); heart.setAttribute('aria-pressed', on ? 'true' : 'false'); };
      paintHeart();
      heart.addEventListener('click', function (e) {
        e.stopPropagation(); e.preventDefault();
        if (hearts[item.u]) { delete hearts[item.u]; } else { hearts[item.u] = 1; heart.classList.remove('is-pop'); void heart.offsetWidth; heart.classList.add('is-pop'); }
        paintHeart(); saveHearts();
      });
      heart.addEventListener('keydown', function (e) { e.stopPropagation(); });
      shot.appendChild(heart);
      }

      if (videos[item.u]) {
        var vbtn = button('mv-lib__video', '<svg viewBox="0 0 12 12" width="10" height="10" aria-hidden="true"><path d="M3 1.5v9l7-4.5z" fill="currentColor"/></svg> Make a video', 'Make a video with ' + item.n);
        vbtn.addEventListener('click', function (e) { e.stopPropagation(); openVideo(item); });
        vbtn.addEventListener('keydown', function (e) { e.stopPropagation(); });
        shot.appendChild(vbtn);
      }

      var entry = { item: item, fig: fig, state: null };
      var tools = null, panel = null;

      /* No account: the worker makes this one from the file itself (/free, one a day per visitor). Only the template
         the studio starts them on can be made this way; anything else asks them to sign up first. */
      function guestMake() {
        if (fig.classList.contains('is-busy')) { return; }
        /* The free template can be made again with another photo (23 Sep, Kaitlin: "people who sample can change pic
           on the billboard 4x"); the worker counts the goes. Anything else asks for the account. This is checked
           BEFORE the file picker: it used to open the picker first, so they went and found a photo and only then
           found out the template was locked. */
        var isFreeOne = !starter || item.u === starter.u;
        if (!isFreeOne) { if (!openPacks(null, 'guest')) { askSignUp(null); } return; }
        if (!currentFile) { fileInput.click(); return; }
        if (entry.state && currentFile === guestShown) { return; }
        coachHide(); hideError(); fig.classList.add('is-busy');
        var gen = photoGen;
        var body = new FormData();
        body.append('image', currentFile); body.append('ratio', String(ratio));
        body.append('fit', opts.fit); body.append('color', opts.fit === 'contain' ? opts.colour : '');
        post('/free', body).then(function (res) {
          if (!res.ok) {
            fig.classList.remove('is-busy');
            /* Out of free tries on this connection: say so in the rail with a way in. Never a pop-up before they have
               seen anything (20 Sep, Kaitlin: "SHOW THEM THE FINISHED MOCKUP AND THEN CREATE ACC TO DOWNLOAD"). */
            /* Swapped too many times: ask for the account, with their last image in the pop-up. They have seen plenty
               by now, so a pop-up is fair (23 Sep). */
            if (res.b.limit) { askSignUp(guestMade || null); }
            else { showError(res.b.error || 'Could not make that one.'); }
            return;
          }
          var fresh = new Image();
          fresh.onload = function () {
            if (gen !== photoGen) { return; }   /* the photo changed while this was making */
            entry.state = { url: res.b.url };
            guestMade = res.b.url; guestShown = currentFile;
            if (res.b.triesLeft != null) { guestTries = res.b.triesLeft; guestMeter(); }
            if (!fig._blank) { fig._blank = img.currentSrc || img.src; } img.src = res.b.url; img.alt = 'Your image on ' + item.n;
            fig.classList.remove('is-busy', 'is-locked'); fig.classList.add('is-yours');
            fig.classList.remove('is-pop'); void fig.offsetWidth; fig.classList.add('is-pop'); popOff(fig);
            mark('first_image');
            guestTools();
            if (hint) { hint.textContent = 'There it is. Make a free account to save it.'; }
            /* Not "5 free credits" (6 Oct): a guest has one free try and an account to make, and the line
               under it said exactly that. Same ruled row as guestMeter, so it reads as one thing. */
            if (meterEl) { meterEl.innerHTML = '<span class="mx-rows"><span class="mx-row"><span>Free to try</span><b>1 mockup</b></span></span><small>Sign up free to keep this one.</small>' + LOGIN; }
            coach('save', fig.querySelector('.mv-lib__txt--dark'), 'Sign up to download.', '', 'top');
          };
          fresh.onerror = function () { fig.classList.remove('is-busy'); showError('Could not load that one. Tap it again.'); };
          fresh.src = res.b.url;
        }).catch(function () { fig.classList.remove('is-busy'); showError('Could not reach the studio. Try again.'); });
      }
      /* One button under a guest's image: Download, which asks for the account first. */
      function guestTools() {
        if (tools) { return; }
        tools = document.createElement('div'); tools.className = 'mv-lib__bar';
        tools.addEventListener('click', function (e) { e.stopPropagation(); });
        var dl = button('mv-lib__txt mv-lib__txt--dark', ICON.download + '<span>Download</span>');
        dl.addEventListener('click', function () { askSignUp(entry.state.url); });
        tools.appendChild(dl);
        (fig._shot || fig).appendChild(tools);
      }

      /* opt.keep leaves a panel open while this runs, and opt.done / opt.fail report back, so the Position
         dialog can show a progress bar instead of vanishing (6 Oct, Kaitlin: "when i click apply it doesnt
         'load' it just happens after 10 seconds"). Returns false when nothing was started, so the caller can
         put its button back. */
      function render(next, opt) {
        opt = opt || {};
        if (guest) { guestMake(); return false; }
        if (fig.classList.contains('is-busy')) { return false; }
        coachHide();
        if (entry.state && entry.changesLeft === 0) { showError('That’s all the changes on this one. Download it, or tap it on another template.'); return false; }
        var cost = entry.state || isFree(item) ? 0 : NEW;
        /* Whether they can afford it is checked BEFORE the file picker (6 Oct, Kaitlin: "when i click top up it
           opens gallery"). Tapping "Top up to use this" with no photo loaded used to send them off to find one,
           and only then say they were out of credits. The guest path was fixed this way on 6 Oct too. */
        if (remaining != null && remaining < cost) { needCredits('You’re out of credits. Top up to keep going.'); return false; }
        if (!next.art && !art && !uploading) {
          queued = function () { render(next, opt); };
          fileInput.click();
          return false;
        }
        hideError(); if (!opt.keep) { closePanel(); }
        fig.classList.add('is-busy');
        var gen = photoGen;
        (next.art ? Promise.resolve(next.art) : art ? Promise.resolve(art) : uploading).then(function (id) {
          var body = new FormData();
          body.append('token', token); body.append('art', next.art || id); body.append('mockup', item.u);
          body.append('rotate', String(next.rotate || 0)); body.append('fit', next.fit); body.append('color', next.fit === 'contain' ? opts.colour : '');
          if (next.box) { body.append('box', JSON.stringify(next.box)); }
          body.append('ratio', String(ratio)); body.append('auto', entry.state ? '0' : '1');
          body.append('spread', next.spread === 'auto' ? 'auto' : next.spread ? '1' : '0'); body.append('all', next.all ? '1' : '0'); body.append('colors', JSON.stringify(next.colours || {}));
          return post('/render', body).then(function (res) {
            if (!res.ok) {
              if (res.b.expired) { art = null; uploading = null; app.classList.remove('has-art'); empty.hidden = false; full.hidden = true; drop.classList.remove('has-file'); step(1); }
              if (res.b.needCredits) { setMeter(res.b); needCredits(res.b.error); throw new Error(''); }
              throw new Error(res.b.error || 'Could not make that one.');
            }
            var usedFree = freeLeft > 0 && Number(res.b.freeLeft) === 0;
            setMeter(res.b);
            var fresh = new Image();
            fresh.onload = function () {
              if (gen !== photoGen) { setMeter(res.b); made.unshift({ item: item, state: { url: res.b.url, art: next.art || id }, past: true, at: Date.now() }); drawTray(); if (opt.fail) { opt.fail(); } return; }   /* the photo changed while this was making: keep it in Made, leave the tile blank */
              entry.state = { url: res.b.url, rotate: res.b.rotate, fit: res.b.fit, box: res.b.box || null, spread: !!res.b.spread, all: !!res.b.all, colours: next.colours || {}, art: next.art || id };
              if (!fig._blank) { fig._blank = img.currentSrc || img.src; } img.src = res.b.url; img.alt = 'Your image on ' + item.n;
              fig.classList.remove('is-busy', 'is-locked'); fig.classList.add('is-yours');
              fig.classList.remove('is-pop'); void fig.offsetWidth; fig.classList.add('is-pop'); popOff(fig);
              if (res.b.changesLeft != null) { entry.changesLeft = res.b.changesLeft; }
              if (!made.length) { mark('first_image'); }
              if (remaining !== Infinity && !freeLeft && remaining > 0 && remaining < NEW * 3 && !lowMarked) { lowMarked = true; mark('low_balance'); }
              showTools(); addToTray(entry); step(3);
              /* An open mockup on a computer: Adjust comes up in the left panel by itself, beside the result. */
              if (fig.classList.contains('is-big') && !panel && !narrow()) { openPos(); }
              if (usedFree) { entry.wasFree = true; }
              /* Nothing after a render either (6 Oct, Kaitlin: "remove this Tap any template to make another.").
                 The balance in the rail already says where they stand. */
              if (hint) { hint.textContent = ''; }
              if (opt.done) { opt.done(); }
            };
            fresh.onerror = function () { fig.classList.remove('is-busy'); showError('Could not load that one. Tap it again.'); if (opt.fail) { opt.fail(); } };
            fresh.src = res.b.url;
          });
        }).catch(function (e) { fig.classList.remove('is-busy'); if (e && e.message) { showError(plainly(e)); } if (opt.fail) { opt.fail(); } });
        return true;
      }

      function withState(changes) {
        var s = entry.state;
        return {
          rotate: 'rotate' in changes ? changes.rotate : s.rotate,
          fit: changes.fit || s.fit,
          /* null clears a hand placement, undefined keeps it (6 Oct). */
          box: 'box' in changes ? changes.box : s.box,
          spread: 'spread' in changes ? changes.spread : s.spread,
          all: 'all' in changes ? changes.all : s.all,
          colours: changes.colours || s.colours,
          art: s.art
        };
      }

      function seg(a, b, label) {
        var wrap = document.createElement('div'); wrap.className = 'mv-lib__seg'; wrap.setAttribute('role', 'group'); wrap.setAttribute('aria-label', label);
        var A = button('mv-lib__segbtn', a[0], a[1]), B = button('mv-lib__segbtn', b[0], b[1]);
        wrap.appendChild(A); wrap.appendChild(B); wrap._a = A; wrap._b = B;
        return wrap;
      }

      function showTools() {
        if (narrow() && entry.state && entry.state.url && entry._bfor !== entry.state.url) {
          var want = entry._bfor = entry.state.url; entry._blob = null;
          fetch(want).then(function (r) { return r.blob(); }).then(function (b) { if (entry._bfor === want) { entry._blob = b; } }).catch(function () {});
        }
        if (!tools) {
          tools = document.createElement('div'); tools.className = 'mv-lib__bar';
          tools.addEventListener('click', function (e) { e.stopPropagation(); });
          /* One door (6 Oct, Kaitlin: "when people click ADJUST then it open this pop up"). Rotate, Fill / Fit and
             the rest used to be a row of icons on the photo; they all live in the dialog now. */
          var adjBtn = button('mv-lib__txt', 'Adjust');
          /* Adjust always sits on the left, never over the photo (3 Nov, Kaitlin: "adjust shouldnt pop up on image it
             just should appear on left"): from the grid it opens the mockup big first, then docks beside it. */
          adjBtn.addEventListener('click', function () {
            if (panel) { closePanel(); return; }
            if (!fig.classList.contains('is-big') && openFocus(fig)) { setTimeout(function () { if (!panel) { openPos(); } }, 260); return; }
            openPos();
          });
          tools.appendChild(adjBtn);
          var dl = button('mv-lib__txt mv-lib__txt--dark', ICON.download + '<span>Download</span>');
          dl.addEventListener('click', function () {
            if (entry._blob && entry._bfor === entry.state.url) { saveImage(entry._blob, fileName(item)); }
            else { fetch(entry.state.url).then(function (r) { return r.blob(); }).then(function (b) { saveImage(b, fileName(item)); }).catch(function () { window.open(entry.state.url, '_blank', 'noopener'); }); }
            /* Their free one is saved: now offer the packs, once (Kaitlin, 19 Sep: not before they can download it). */
            step('done');
            /* No "Saved. Tap any other photo" bubble after a download (6 Oct, Kaitlin: "remove this shit pop up").
               It landed over the tabs and said nothing they couldn't see. */
            if (entry.wasFree && remaining < NEW && !freeLeft && !offered) { offered = true; setTimeout(function () { openPacks(entry.state.url); }, 1400); }
          });
          tools.appendChild(dl);
          /* A way out of the buttons (6 Oct, Kaitlin: "need x button to get out"). They sit over the finished
             photo, so after a render there was no way to see the whole thing. Tapping the photo brings them back. */
          var shut = button('mv-lib__shut', '\u00d7', 'Hide these buttons');
          shut.addEventListener('click', function (e) { e.stopPropagation(); fig.classList.add('is-shut'); fig.classList.remove('is-pop'); });
          tools.appendChild(shut);
          (fig._shot || fig).appendChild(tools);
        }
        /* Changes are free but capped per image (worker CHANGES_PER_IMAGE); say so once only a few are left. */
        if (!tools._left) { tools._left = document.createElement('span'); tools._left.className = 'mv-lib__left'; tools.appendChild(tools._left); }
        var left = entry.changesLeft;
        tools._left.hidden = !(left != null && left <= 3);
        tools._left.textContent = left === 0 ? 'No changes left' : left + (left === 1 ? ' change left' : ' changes left');
        fig.classList.toggle('is-maxed', left === 0);
      }

      /* Colours: one row per COLOR layer, each with a colour picker. */
      function openPanel() {
        closeAllPanels();
        var picks = JSON.parse(JSON.stringify(entry.state.colours || {}));
        panel = document.createElement('div'); panel.className = 'mv-lib__panel';
        panel.addEventListener('click', function (e) { e.stopPropagation(); });
        var h = document.createElement('p'); h.className = 'mv-lib__panel-title'; h.textContent = 'Colours'; panel.appendChild(h);
        item.c.forEach(function (layer) {
          var row = document.createElement('div'); row.className = 'mv-lib__row';
          var label = document.createElement('span'); label.textContent = layer.n; row.appendChild(label);
          /* A picker per layer, like Canva: a colour well, the hex code, and Original to leave it as shot. */
          var sw = document.createElement('div'); sw.className = 'mv-lib__picker';
          var well = document.createElement('input'); well.type = 'color'; well.className = 'mv-lib__well';
          well.value = picks[layer.u] || '#ffffff'; well.setAttribute('aria-label', 'Colour for ' + layer.n);
          var code = document.createElement('input'); code.type = 'text'; code.className = 'mv-lib__hex'; code.maxLength = 7; code.spellcheck = false;
          code.value = picks[layer.u] || ''; code.placeholder = 'Original'; code.setAttribute('aria-label', 'Hex code for ' + layer.n);
          var reset = button('mv-lib__link', 'Original');
          function paint() { row.classList.toggle('is-set', !!picks[layer.u]); }
          well.addEventListener('input', function () { picks[layer.u] = well.value; code.value = well.value; paint(); });
          code.addEventListener('input', function () {
            var v = code.value.trim(); if (v && v[0] !== '#') { v = '#' + v; }
            if (/^#[0-9a-f]{6}$/i.test(v)) { picks[layer.u] = v.toLowerCase(); well.value = v; paint(); }
          });
          reset.addEventListener('click', function () { delete picks[layer.u]; code.value = ''; well.value = '#ffffff'; paint(); });
          sw.appendChild(well); sw.appendChild(code); sw.appendChild(reset);
          paint();
          row.appendChild(sw); panel.appendChild(row);
        });
        var actions = document.createElement('div'); actions.className = 'mv-lib__panel-actions';
        var cancel = button('mv-lib__link', 'Cancel'), apply = button('mv-lib__apply', 'Apply');
        cancel.addEventListener('click', closePanel);
        apply.addEventListener('click', function () { render(withState({ colours: picks })); });
        actions.appendChild(cancel); actions.appendChild(apply); panel.appendChild(actions);
        fig.appendChild(panel); fig.classList.add('has-panel');
      }
      /* Position: drag their image around the design area and scale it, the way Dynamic Mockups' own editor does
         (6 Oct, Kaitlin: "if they click adjust can manually adjust like how dynamic mockups has that option").
         The stage is the design area's own shape (`r` in me-library.json), so what they drag is what gets
         rendered. The box goes to the worker as FRACTIONS of that area, which is why a mixed template can apply
         the same placement to every design area without the browser knowing any pixel sizes.
         Not offered on a two-page spread: there the worker owns size and position. */
      function openPos() {
        closeAllPanels();
        var stageAR = Number(item.r) || 1;
        var imgAR = ratio || 1;
        /* A quarter turn changes the shape the stage has to hold, so the fit is worked out on the image AS SEEN
           (6 Oct, Kaitlin: "have option to rotate"). Without this a turned photo was squashed into the stage. */
        var rot = entry.state.rotate || 0;
        var baseW, baseH, coverZ;
        /* z = 1 is the whole image inside the area. baseW/baseH are its size then, as fractions of the area,
           and they are what keep the preview from stretching: the stage image is object-fit:fill, because that
           is what Dynamic Mockups does with an explicit size. */
        function measure() {
          var eff = (rot % 180) ? 1 / imgAR : imgAR;
          baseW = eff > stageAR ? 1 : eff / stageAR;
          baseH = eff > stageAR ? stageAR / eff : 1;
          coverZ = Math.max(1 / baseW, 1 / baseH);
        }
        measure();
        var st = entry.state.box
          ? { z: entry.state.box.w / baseW, cx: entry.state.box.l + entry.state.box.w / 2, cy: entry.state.box.t + entry.state.box.h / 2 }
          : { z: entry.state.fit === 'cover' ? coverZ : 1, cx: .5, cy: .5 };
        /* A centred dialog, not a bubble inside the tile (6 Oct, Kaitlin: "its cropped on top row of mockups..
           and glitching too"). The tile clips what overflows it, so on the top row the panel's head was cut off
           and a drag ran out of sight, which is what read as glitching. */
        var back = document.createElement('div'); back.className = 'mv-lib__posback';
        back.addEventListener('click', function (e) { if (e.target === back) { closePanel(); } });
        panel = document.createElement('div'); panel.className = 'mv-lib__panel mv-lib__pos';
        panel._back = back;
        panel.addEventListener('click', function (e) { e.stopPropagation(); });
        var esc = function (e) { if (e.key === 'Escape') { closePanel(); } };
        document.addEventListener('keydown', esc);
        panel._off = function () { document.removeEventListener('keydown', esc); };
        var head = document.createElement('div'); head.className = 'mv-lib__pos-head';
        var h = document.createElement('p'); h.className = 'mv-lib__panel-title'; h.textContent = 'Adjust';
        var shut = button('mv-lib__pos-x', '\u00d7', 'Close');
        shut.addEventListener('click', closePanel);
        head.appendChild(h); head.appendChild(shut); panel.appendChild(head);
        /* The photo in use and Change, one row (3 Nov, Kaitlin: "i dont like photos on top here, they could have
           100 photos in library"). It used to be a strip of every recent upload. Change opens Uploads beside the
           mockup, where every photo is, and picking one there makes this mockup again with it (setFile renders the
           open mockup). Phones already have Change photo and their uploads under the mockup, so no row there. */
        if (!narrow()) {
          var row = document.createElement('div'); row.className = 'mv-lib__photo';
          var th = document.createElement('img'); th.alt = ''; th.decoding = 'async';
          th.src = entry.state.art && entry.state.art !== art ? endpoint + '/art/' + entry.state.art : preview.src;
          var lab = document.createElement('span'); lab.className = 'mv-lib__photo-label'; lab.textContent = 'Photo';
          var chg = button('mv-lib__photo-change', 'Change', 'Change photo');
          chg.addEventListener('click', function () {
            closePanel();
            if (!fig.classList.contains('is-big')) { openFocus(fig); } else if (dockGo) { dockGo('uploads'); }
          });
          row.appendChild(th); row.appendChild(lab); row.appendChild(chg);
          panel.appendChild(row);
        }
        var stage = document.createElement('div'); stage.className = 'mv-lib__stage';
        stage.style.aspectRatio = String(stageAR);
        /* Cap the HEIGHT by capping the width, so aspect-ratio always holds: a max-height on a box with
           width:100% squashes it, and the image inside is positioned in percentages of the stage, so a squashed
           stage shows them a placement that isn't the one they'll get. */
        stage.style.maxWidth = Math.round(280 * stageAR) + 'px';
        var shot = document.createElement('img'); shot.className = 'mv-lib__stage-img'; shot.alt = ''; shot.draggable = false;
        /* Take the shape from THIS image once it has loaded, not from `ratio` (6 Oct, Kaitlin: "when i reduce
           size it shows that its full landscape and not narrower but it warps it"). `ratio` is set in an onload
           on the rail preview, so a panel opened before that landed sized the box to 1:1 and the photo was
           stretched into it. Reading it here cannot be stale, and the opening state then matches the tile. */
        shot.addEventListener('load', function () {
          if (!shot.naturalWidth || !shot.naturalHeight) { return; }
          var real = shot.naturalWidth / shot.naturalHeight;
          if (Math.abs(real - imgAR) < 0.005) { return; }
          var wasCover = Math.abs(st.z - coverZ) < 0.005;
          imgAR = ratio = real; measure();
          if (wasCover) { st.z = coverZ; }
          paint();
        });
        /* a reopened project shows its own photo, not whatever is loaded now */
        shot.src = entry.state && entry.state.art && entry.state.art !== art ? endpoint + '/art/' + entry.state.art : preview.src;
        stage.appendChild(shot); panel.appendChild(stage);
        /* Fill and Fit are presets for the placement now, not a separate render: the box IS the placement, so
           Fill is "box covers the area" and Fit is "box inside it". They change the preview; Apply sends it. */
        var pre = seg(['Fill', 'Fill the surface'], ['Fit', 'Show the whole design'], 'Fill or fit');
        pre.classList.add('mv-lib__pospre');
        pre._a.addEventListener('click', function () { st.z = coverZ; st.cx = .5; st.cy = .5; paint(); });
        pre._b.addEventListener('click', function () { st.z = 1; st.cx = .5; st.cy = .5; paint(); });
        panel.appendChild(pre);
        var zoom = document.createElement('div'); zoom.className = 'mv-lib__row mv-lib__zoom';
        var zl = document.createElement('span'); zl.textContent = 'Size';
        var zi = document.createElement('input'); zi.type = 'range'; zi.min = '20'; zi.max = '400'; zi.step = '1';
        zi.setAttribute('aria-label', 'Size of your image on the template');
        zoom.appendChild(zl); zoom.appendChild(zi); panel.appendChild(zoom);
        /* No "Drag to move it." line (6 Oct, Kaitlin). The bar below takes its place while it renders. */
        var bar = document.createElement('div'); bar.className = 'mv-lib__posbar'; bar.hidden = true;
        bar.innerHTML = '<span></span>'; panel.appendChild(bar);
        function paint() {
          var w = baseW * st.z, hh = baseH * st.z;
          /* w/hh are the footprint on screen. CSS rotates around the centre and keeps the layout box, so on a
             quarter turn the element is laid out the other way round first. Written as fractions using the
             stage's own ratio, so nothing has to be measured in pixels. */
          var turned = (rot % 180) !== 0;
          var ew = turned ? hh / stageAR : w, eh = turned ? w * stageAR : hh;
          shot.style.width = (ew * 100) + '%'; shot.style.height = (eh * 100) + '%';
          shot.style.left = ((st.cx - ew / 2) * 100) + '%'; shot.style.top = ((st.cy - eh / 2) * 100) + '%';
          shot.style.transform = rot ? 'rotate(' + (-rot) + 'deg)' : '';
          zi.value = String(Math.round(st.z * 100));
          var mid = Math.abs(st.cx - .5) < .003 && Math.abs(st.cy - .5) < .003;
          pre._a.setAttribute('aria-pressed', mid && Math.abs(st.z - coverZ) < .006 ? 'true' : 'false');
          pre._b.setAttribute('aria-pressed', mid && Math.abs(st.z - 1) < .006 ? 'true' : 'false');
        }
        zi.addEventListener('input', function () { st.z = Math.max(.2, Number(zi.value) / 100); paint(); });
        /* One pointer drags; the stage keeps the gesture so a fast drag off its edge still tracks. */
        var from = null;
        stage.addEventListener('pointerdown', function (e) {
          from = { x: e.clientX, y: e.clientY, cx: st.cx, cy: st.cy, w: stage.clientWidth, h: stage.clientHeight };
          stage.setPointerCapture(e.pointerId); stage.classList.add('is-dragging'); e.preventDefault();
        });
        stage.addEventListener('pointermove', function (e) {
          if (!from) { return; }
          st.cx = from.cx + (e.clientX - from.x) / from.w;
          st.cy = from.cy + (e.clientY - from.y) / from.h;
          paint();
        });
        var drop = function () { from = null; stage.classList.remove('is-dragging'); };
        stage.addEventListener('pointerup', drop); stage.addEventListener('pointercancel', drop);
        paint();
        /* Everything else that used to sit on the photo. These re-render on the spot, which closes the dialog. */
        var more = document.createElement('div'); more.className = 'mv-lib__posmore';
        var rotBtn = button('mv-lib__link', 'Rotate');
        rotBtn.addEventListener('click', function () {
          if (panel._busy) { return; }
          var wasCover = Math.abs(st.z - coverZ) < .006;
          rot = (rot + 270) % 360; measure();
          if (wasCover) { st.z = coverZ; }
          paint();
        });
        more.appendChild(rotBtn);
        if (item.c) {
          var col = button('mv-lib__link', 'Colours');
          col.addEventListener('click', function () { if (!panel._busy) { openPanel(); } });
          more.appendChild(col);
        }
        if (item.sp) {
          /* Plain words (21 Sep, Kaitlin: "is there an easier way to explain this"): one image across both pages,
             or the whole image on each page. */
          var spSeg = seg(['Across both', 'One image across both pages'], ['On each', 'The whole image on each page'], 'Across both pages or on each page');
          spSeg._a.addEventListener('click', function () { if (!panel._busy) { render(withState({ spread: true })); } });
          spSeg._b.addEventListener('click', function () { if (!panel._busy) { render(withState({ spread: false })); } });
          spSeg._a.setAttribute('aria-pressed', entry.state.spread ? 'true' : 'false');
          spSeg._b.setAttribute('aria-pressed', entry.state.spread ? 'false' : 'true');
          more.appendChild(spSeg);
        }
        if (item.mx) {
          var mxSeg = seg(['One', 'Only the main item'], ['All', 'Every item in the photo'], 'One item or all');
          mxSeg._a.addEventListener('click', function () { if (!panel._busy) { render(withState({ all: false })); } });
          mxSeg._b.addEventListener('click', function () { if (!panel._busy) { render(withState({ all: true })); } });
          mxSeg._a.setAttribute('aria-pressed', entry.state.all ? 'false' : 'true');
          mxSeg._b.setAttribute('aria-pressed', entry.state.all ? 'true' : 'false');
          more.appendChild(mxSeg);
        }
        panel.appendChild(more);
        var actions = document.createElement('div'); actions.className = 'mv-lib__panel-actions';
        var reset = button('mv-lib__link', 'Reset'), apply = button('mv-lib__apply', 'Apply');
        reset.addEventListener('click', function () { st.z = coverZ; st.cx = .5; st.cy = .5; paint(); });
        apply.addEventListener('click', function () {
          if (panel._busy) { return; }
          var w = baseW * st.z, hh = baseH * st.z;
          /* Stay open and show a bar while Dynamic Mockups renders it: it takes seconds, and the dialog
             covers the tile, so closing straight away looked like nothing had happened. */
          var rest = function () { panel._busy = false; panel.classList.remove('is-busy'); bar.hidden = true; apply.disabled = false; apply.textContent = 'Apply'; };
          panel._busy = true; panel.classList.add('is-busy'); bar.hidden = false;
          apply.disabled = true; apply.textContent = 'Applying';
          var went = render(withState({ rotate: rot, box: { l: st.cx - w / 2, t: st.cy - hh / 2, w: w, h: hh } }),
            { keep: true, done: function () { if (panel && panel.classList.contains('is-docked')) { rest(); } else { closePanel(); } }, fail: rest });
          if (!went) { rest(); }
        });
        actions.appendChild(reset); actions.appendChild(apply); panel.appendChild(actions);
        /* Into the studio itself, not the body: the editorial styles are all scoped `.mv-studio …`, and the
           studio is already position:fixed with no transform, so a fixed child still covers the window. */
        /* On a two-page spread the worker sizes and places the artwork itself, so there is nothing here to drag.
           The dialog still opens, with the controls that do apply. */
        if (entry.state.spread) { stage.hidden = true; zoom.hidden = true; pre.hidden = true; reset.hidden = true; apply.hidden = true; }
        /* An open mockup keeps Adjust beside it, not over it (3 Nov, Kaitlin: "where should adjust box go? on
           the left"): the left panel on a computer, under the mockup on a phone. In the grid it's the dialog. */
        if (fig.classList.contains('is-big') && dockPanel(panel)) { panel._back = null; } else { back.appendChild(panel); app.appendChild(back); }
        fig.classList.add('has-panel');
      }
      function closePanel() {
        if (!panel) { return; }
        if (panel._off) { panel._off(); }
        var wasDocked = panel.classList.contains('is-docked');
        (panel._back || panel).remove();
        if (wasDocked && dockGo && !narrow() && railPane() === 'adjust') { dockGo('uploads'); }
        panel = null; fig.classList.remove('has-panel');
      }
      fig._closePanel = closePanel;
      /* A new photo, or the x on the current one, puts made tiles back to blank so they can be made again
         (19 Oct, Kaitlin: "if i use a template and then cancel and want to change it it doesnt let me click use
         this template its stuck on the old one"). first() only renders a tile with no state, so a made tile used to
         keep the old image and ignore every tap. What was made stays in the Made tray, as a download. */
      fig._reset = function () {
        fig.classList.remove('is-busy');
        if (!entry.state) { return; }
        var at = made.indexOf(entry);
        if (at !== -1) { made[at] = { item: item, state: entry.state, past: true }; }
        entry.state = null; entry.changesLeft = null; entry.wasFree = false;
        closePanel();
        if (tools) { tools.remove(); tools = null; }
        fig.classList.remove('is-yours', 'is-shut', 'is-pop', 'is-maxed', 'is-flash');
        if (fig._blank) { img.src = fig._blank; } img.alt = item.n;
        lockState(fig);
      };

      /* sd: a real two-page spread; the worker spreads their image across both pages or repeats it on each, whichever
         crops less of it (spread: 'auto'), and Across both | On each under Adjust switches. ad: a mixed template where every item should carry the
         design from the start (iPad with paper black heels: a blank iPad among branded papers looks unfinished). */
      function first() { if (!entry.state) { render({ rotate: 0, fit: opts.fit, spread: item.sd ? 'auto' : false, all: !!item.ad, colours: {} }); } }
      /* Tapping the photo brings the buttons back after the x hid them. */
      fig.addEventListener('click', function () { fig.classList.remove('is-shut'); });
      /* a finished one opens the editor too on a phone, where Adjust and Download live in its toolbar */
      fig.addEventListener('click', function () { if ((!entry.state || narrow()) && !fig.classList.contains('is-big') && openFocus(fig)) { return; } first(); });
      fig._item = item; fig._first = first;
      /* A project from Made, reopened (3 Nov, Kaitlin: "like how canva has projects you scroll through"): the tile
         takes the finished image and the settings it was made with (the worker's signature, rotate|fit|colour|
         spread|all|colours|box), so Adjust carries on from there on the same photo. */
      fig._restore = function (m) {
        /* one put back by a new photo this visit still has its settings as they were */
        if (!m.s && m.state.fit) { entry.state = Object.assign({}, m.state); } else {
        var p = String(m.s || '').split('|'), box = null, colours = {};
        if (p[6]) { var b = p[6].split(',').map(Number); box = { l: b[0], t: b[1], w: b[2], h: b[3] }; }
        (p[5] || '').split(',').filter(Boolean).forEach(function (x) { var k = x.split(':'); colours[k[0]] = k[1]; });
        entry.state = { url: m.state.url, rotate: Number(p[0]) || 0, fit: p[1] || 'cover', box: box, spread: p[3] === '1', all: p[4] === '1', colours: colours, art: m.state.art };
        }
        if (!fig._blank) { fig._blank = img.getAttribute('src'); }
        img.addEventListener('load', function () { if (img.naturalWidth) { fig.style.setProperty('--ar', String(img.naturalWidth / img.naturalHeight)); } });
        img.src = m.state.url; img.alt = 'Your image on ' + item.n;
        fig.classList.remove('is-locked'); fig.classList.add('is-yours', 'is-loaded');
        showTools();
      };
      fig._adjust = function () { if (!panel && entry.state) { openPos(); } };
      lockState(fig);
      fig.tabIndex = 0;
      fig.addEventListener('keydown', function (e) { if ((e.key === 'Enter' || e.key === ' ') && e.target === fig) { e.preventDefault(); fig.click(); } });
      return fig;
    }
    /* First logo in, nothing made yet, and their free image is waiting: put it on the billboard at the top of All
       and make it. Never spends a paid image. ALWAYS the billboard, whatever the shape (6 Oct, Kaitlin: "when i
       uplaoded pic it went ot laptop? not billboard"): the billboard is the one pinned first and labelled Free, and
       the examples all show it, so sending a landscape photo to the MacBook instead made the labels lie. */
    function autoStart() {
      if (made.length || queued || !(freeLeft > 0) || !all.length) { return; }
      var want = /vertical city billboard/i, it = null;
      all.forEach(function (x) { if (!it && want.test(x.n)) { it = x; } });
      if (!it) { return; }
      starter = it;
      [all, mixed].forEach(function (arr) { var k = arr.indexOf(it); if (k > -1) { arr.splice(k, 1); arr.unshift(it); } });
      setCategory(allIndex());
      var ft = firstTile(); if (ft && ft._first) { ft._first(); }
    }

    /* ---- One mockup at a time (3 Nov, Kaitlin: "when they click their mockup they want to edit it crossfades and
       removes the other ones and then makes that mockup big and then the uploads panel on left"). Tapping a blank
       template fades the library out and brings that one up big, the Uploads panel opens in the rail, and they drag
       a photo onto it (or tap one, or drop a file from the computer). The tile itself moves into the focus view, so
       its render, Adjust and Download all work as they do in the grid. Back puts it where it was. */
    var focusFig = null, focusHome = null, focusNext = null, focusBox = null, focusPrevPane = null, dragRec = null;
    function focusView() {
      if (focusBox) { return focusBox; }
      focusBox = document.createElement('div'); focusBox.className = 'mv-focus'; focusBox.hidden = true;
      var bar = document.createElement('div'); bar.className = 'mv-focus__bar';
      var back = button('mv-focus__back', '← All mockups');
      back.addEventListener('click', function () { closeFocus(); });
      bar.appendChild(back);
      focusBox.appendChild(bar);
      focusBox._hold = document.createElement('div'); focusBox._hold.className = 'mv-focus__hold';
      focusBox.appendChild(focusBox._hold);
      /* Phones can't drag, so one button under the mockup: Add photo, then Change photo once it's on
         (3 Nov, Kaitlin: "you should click add photo then be able to change it"). Hidden on a computer. */
      var up = button('mv-focus__up', '<span class="mv-focus__add">Add photo</span><span class="mv-focus__change">Change photo</span>');
      up.addEventListener('click', function () { fileInput.click(); });
      focusBox.appendChild(up);
      /* Phones edit like Canva (3 Nov, Kaitlin: "recent uploads needs to be in diff tab and adjust when in editing
         mode on mobile… should be more like canva"): the mockup on its own, a toolbar along the bottom, and Photos
         slides up as a sheet with their uploads. Adjust and Download are the tile's own buttons, pressed from here,
         so they behave exactly as they do on a computer. Hidden on a computer. */
      var tools = document.createElement('div'); tools.className = 'mv-tools';
      var sheet = document.createElement('div'); sheet.className = 'mv-sheet'; sheet.hidden = true;
      sheet.innerHTML = '<div class="mv-sheet__head"><span>Photos</span></div>';
      var shut = button('mv-sheet__x', '\u00d7', 'Close');
      shut.addEventListener('click', function () { sheet.hidden = true; });
      sheet.firstChild.appendChild(shut);
      var add = button('mv-sheet__up', 'Upload photo');
      add.addEventListener('click', function () { sheet.hidden = true; fileInput.click(); });
      sheet.appendChild(add);
      sheet._body = document.createElement('div'); sheet._body.className = 'mv-sheet__body';
      sheet.appendChild(sheet._body);
      focusBox._sheet = sheet;
      /* the mockup makes room while the sheet is up (CSS .has-sheet) */
      new MutationObserver(function () { focusBox.classList.toggle('has-sheet', !sheet.hidden); }).observe(sheet, { attributes: true, attributeFilter: ['hidden'] });
      function own(sel) { return focusFig && focusFig.querySelector('.mv-lib__bar ' + sel); }
      [['photos', 'Photos', '<rect x="4" y="5" width="16" height="14" rx="1"/><path d="M4 16l5-5 4 4 3-3 4 4"/><circle cx="15.5" cy="9" r="1.3"/>'],
        ['adjust', 'Adjust', '<path d="M5 7h9M18 7h1M5 17h3M12 17h7"/><circle cx="16" cy="7" r="2"/><circle cx="10" cy="17" r="2"/>'],
        ['download', 'Download', '<path d="M12 4v11M7 10l5 5 5-5M5 20h14"/>']].forEach(function (t) {
        var b = button('mv-tools__btn mv-tools__btn--' + t[0], '<svg viewBox="0 0 24 24" aria-hidden="true">' + t[2] + '</svg><span>' + t[1] + '</span>');
        b.addEventListener('click', function () {
          var mine = t[0] === 'adjust' ? own('.mv-lib__txt:not(.mv-lib__txt--dark)') : t[0] === 'download' ? own('.mv-lib__txt--dark') : null;
          /* nothing made yet: Adjust and Download have nothing to work on, so they ask for a photo first */
          if (t[0] === 'photos' || !mine) { if (focusFig && focusFig._closePanel) { focusFig._closePanel(); } sheet.hidden = !sheet.hidden; return; }
          sheet.hidden = true; mine.click();
        });
        tools.appendChild(b);
      });
      focusBox.appendChild(sheet);
      focusBox.appendChild(tools);
      grid.parentNode.insertBefore(focusBox, grid);
      /* Dropping onto the big mockup: a photo from Uploads, or a file from the computer. */
      var hold = focusBox._hold;
      ['dragenter', 'dragover'].forEach(function (ev) {
        hold.addEventListener(ev, function (e) { if (!focusFig) { return; } e.preventDefault(); e.dataTransfer.dropEffect = 'copy'; focusFig.classList.add('is-over'); });
      });
      hold.addEventListener('dragleave', function (e) { if (focusFig && !hold.contains(e.relatedTarget)) { focusFig.classList.remove('is-over'); } });
      hold.addEventListener('drop', function (e) {
        if (!focusFig) { return; }
        e.preventDefault(); focusFig.classList.remove('is-over'); app.classList.remove('is-dragging', 'is-carrying');
        var f = dragRec ? recFile(dragRec) : (e.dataTransfer.files && e.dataTransfer.files[0]);
        dragRec = null;
        if (f) { setFile(f); }
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && focusFig && !focusFig.classList.contains('has-panel')) { closeFocus(); } });
      return focusBox;
    }
    /* Adjust for the open mockup: into the rail as its own pane on a computer, under the mockup on a phone. */
    function dockPanel(panel) {
      if (!focusBox) { return false; }
      panel.classList.add('is-docked');
      var rail = app.querySelector('.mv-studio__rail');
      if (narrow() || !rail || !dockGo) {
        focusBox.insertBefore(panel, focusBox._hold.nextSibling);
        setTimeout(function () { panel.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); }, 50);
        return true;
      }
      var holder = rail.querySelector('.mv-pane--adjust');
      if (!holder) {
        holder = document.createElement('div'); holder.className = 'mv-pane mv-pane--adjust';
        var logo = rail.querySelector('.mv-studio__logo');
        rail.insertBefore(holder, logo ? logo.nextSibling : rail.firstChild);
      }
      holder.innerHTML = ''; holder.appendChild(panel);
      dockGo('adjust');
      return true;
    }
    /* Tapping a project in Made: back to the Photo library and that mockup open big, Adjust beside it. One made this
       visit is its own tile; an older one gets a fresh tile, which goes again when it's closed (its home is a div
       that isn't on the page). */
    function openProject(m) {
      var vt = document.querySelector('[data-lib-tab="photo"]');
      if (vt && vt.getAttribute('aria-selected') !== 'true') { vt.click(); }
      if (cats[current] && cats[current].owned) { setCategory(allIndex()); }
      if (dockGo) { dockGo('create'); }
      var fig = !m.past && m.fig && m.fig.isConnected ? m.fig : null;
      if (!fig) {
        fig = tile(m.item, 0);
        fig._restore(m);
        document.createElement('div').appendChild(fig);
      }
      if (!openFocus(fig)) { return; }
      setTimeout(function () { if (focusFig === fig && !narrow()) { fig._adjust(); } }, 260);
    }
    function openFocus(fig) {
      var item = fig._item;
      /* A guest's locked tiles still ask for the account, as before. */
      if (guest && starter && item.u !== starter.u) { return false; }
      if (focusFig === fig) { return false; }
      /* one open mockup at a time: another one opened meanwhile goes back to the grid first, or both sat side by side */
      if (focusFig) { closeFocus(true); }
      var box = focusView();
      closeAllPanels(); coachHide();
      focusHome = fig.parentNode; focusNext = fig.nextSibling; focusFig = fig;
      var im = fig.querySelector('.mv-lib__shot > img');
      /* The shape comes from whichever of its photos has loaded (the blank, an example, their render). One still
         lazy-loading is told to load now and gives its shape when it lands, or a tall mockup is sized as a 3:4 one
         and runs under the phone's toolbar. */
      var seen = Array.prototype.filter.call(fig.querySelectorAll('.mv-lib__shot img'), function (x) { return x.naturalWidth; })[0];
      if (seen) { fig.style.setProperty('--ar', String(seen.naturalWidth / seen.naturalHeight)); }
      else if (im) { im.loading = 'eager'; im.addEventListener('load', function () { if (focusFig === fig && im.naturalWidth) { fig.style.setProperty('--ar', String(im.naturalWidth / im.naturalHeight)); } }, { once: true }); }
      app.classList.add('is-focusing');
      setTimeout(function () {
        if (focusFig !== fig) { return; }
        box._hold.appendChild(fig);
        fig.classList.add('is-big');
        box.hidden = false; app.classList.add('is-focus');
        if (scroller) { scroller.scrollTop = 0; }
        requestAnimationFrame(function () { app.classList.remove('is-focusing'); });
      }, 220);
      /* The rail turns into Uploads on a computer, so their photos are right beside it to drag across. A phone's
         Uploads pane covers the screen, so there the + Upload photo button above the mockup does the job. */
      if (dockGo && !narrow()) { focusPrevPane = railPane(); dockGo('uploads'); }
      /* Phones: their recent uploads come along as a row under the mockup, one tap each, so there's no hunting
         through the camera roll for a photo they've already used. */
      if (narrow() && recentEl) { recentEl._home = recentEl.parentNode; recentEl._next = recentEl.nextSibling; box._sheet._body.appendChild(recentEl); }
      box._sheet.hidden = true;
      /* A blank mockup on a phone opens with Photos up, so the next step is right there */
      if (narrow()) { setTimeout(function () { if (focusFig === fig && !fig.querySelector('.mv-lib__bar') && !fig.classList.contains('is-busy')) { box._sheet.hidden = false; } }, 260); }
      return true;
    }
    function closeFocus(now) {
      if (!focusFig) { return; }
      var fig = focusFig, home = focusHome, next = focusNext;
      focusFig = null; queued = null;
      if (fig._closePanel) { fig._closePanel(); }
      function put() {
        fig.classList.remove('is-big', 'is-over');
        /* The grid was display:none while the mockup was open, which restarts every tile's fade-in: back out, the
           page sat white while they came up one by one (3 Nov, Kaitlin: "everything around it is white"). */
        Array.prototype.forEach.call(app.querySelectorAll('.mv-lib__tile'), function (t) { t.classList.add('is-seen'); });
        fig.style.removeProperty('--ar');
        /* The grid may have been rebuilt meanwhile (a chip, a sort): then the tile has no home and goes. */
        if (home && home.isConnected) { home.insertBefore(fig, next && next.parentNode === home ? next : null); } else { fig.remove(); }
        focusBox.hidden = true; app.classList.remove('is-focus');
        if (narrow()) { app.classList.remove('is-focusing'); }
        requestAnimationFrame(function () { app.classList.remove('is-focusing'); if (fig.isConnected && !now) { fig.scrollIntoView({ block: 'center' }); } });
      }
      if (dockGo && focusPrevPane && !narrow()) { dockGo(focusPrevPane); } focusPrevPane = null;
      if (focusBox._sheet) { focusBox._sheet.hidden = true; }
      if (recentEl && recentEl._home && focusBox.contains(recentEl)) { recentEl._home.insertBefore(recentEl, recentEl._next || null); recentEl._home = null; }
      /* on a phone the library is just there again, no fade from white */
      if (now || narrow()) { put(); return; }
      app.classList.add('is-focusing');
      setTimeout(put, 220);
    }
    function closeAllPanels() { Array.prototype.forEach.call(app.querySelectorAll('.has-panel'), function (f) { if (f._closePanel) { f._closePanel(); } }); }
    /* (Not while a mockup is open: Adjust sits beside it then and closes with its own ×.) */
    document.addEventListener('click', function (e) { if (focusFig) { return; } if (!e.target.closest || !e.target.closest('.mv-lib__panel, .mv-lib__bar')) { closeAllPanels(); } });

    /* ---- video editor ---- */
    function uuid() {
      if (window.crypto && crypto.randomUUID) { return crypto.randomUUID(); }
      return 'xxxxxxxx-xxxx-4xxx-8xxx-xxxxxxxxxxxx'.replace(/x/g, function () { return (Math.random() * 16 | 0).toString(16); });
    }
    function openVideo(item) {
      var v = videos[item.u];
      if (!v || !window.MeReveal) { showError('The video editor didn’t load. Refresh the page and try again.'); return; }
      var video = uuid(), arts = new Map(), frames = new Map(), paid = false;
      function fail(res, fallback) {
        var e = new Error(res.b.error || fallback);
        if (res.b.needCredits) { e.link = { href: pricing, label: 'See image packs' }; }
        if (res.b.credits != null || res.b.unlimited) { setMeter(res.b); }
        return e;
      }
      /* each photo is uploaded once; the studio's own image reuses its upload */
      function artFor(file) {
        if (file === currentFile && (art || uploading)) { return art ? Promise.resolve(art) : uploading; }
        if (!arts.has(file)) {
          var body = new FormData(); body.append('token', token); body.append('image', file);
          arts.set(file, post('/upload', body).then(function (res) {
            if (!res.ok) { throw fail(res, 'Could not save that photo.'); }
            return res.b.art;
          }).catch(function (e) { arts.delete(file); throw e; }));
        }
        return arts.get(file);
      }
      /* stack frames are cached by the photos on their papers, so changes only render what changed. The first frame
         of a new video goes on its own, because that's the one that uses the image. */
      function frameFor(ids) {
        var key = ids.join('|');
        if (!frames.has(key)) {
          var body = new FormData();
          body.append('token', token); body.append('video', video); body.append('mockup', item.u); body.append('arts', JSON.stringify(ids));
          frames.set(key, post('/frame', body).then(function (res) {
            if (!res.ok) { throw fail(res, 'Could not make that frame.'); }
            paid = true; setMeter(res.b); return res.b.url;
          }).catch(function (e) { frames.delete(key); throw e; }));
        }
        return frames.get(key);
      }
      var opts = {
        blank: v.blank, map: v.map, template: item.n,
        photos: currentFile ? [currentFile] : undefined,
        onMade: function (blob, name) { made.unshift({ video: URL.createObjectURL(blob), name: fileName(item).replace(/\.jpg$/, '-video.' + (name.split('.').pop() || 'mp4')), item: item }); drawTray(); }
      };
      if (v.mode === 'stack') {
        opts.stack = { min: 2, max: 10 };
        opts.costNote = 'One video uses 20 credits. Changes are free.';
        opts.render = function (files) {
          return Promise.all(files.map(artFor)).then(function (ids) {
            var n = ids.length;
            var specs = ids.map(function (_, k) { return [0, 1, 2, 3].map(function (i) { return ids[((k - i) % n + n) % n]; }); });
            return (paid ? Promise.resolve() : frameFor(specs[0])).then(function () { return Promise.all(specs.map(frameFor)); });
          });
        };
      } else {
        opts.render = function (file) {
          return artFor(file).then(function (id) {
            var body = new FormData();
            body.append('token', token); body.append('art', id); body.append('mockup', item.u);
            body.append('rotate', '0'); body.append('fit', 'cover'); body.append('color', ''); body.append('ratio', String(ratio));
            body.append('auto', '1'); body.append('spread', '0'); body.append('all', '0'); body.append('colors', '{}');
            return post('/render', body);
          }).then(function (res) {
            if (!res.ok) { throw fail(res, 'Could not put your photo on it. Try again.'); }
            setMeter(res.b); return res.b.url;
          });
        };
      }
      window.MeReveal.open(opts);
    }

    /* ---- grid, categories, endless loading ---- */
    /* Masonry in fixed columns (19 Sep): the grid used CSS columns, which rebalance every time a batch loads, so
       tiles jumped up above where people had scrolled and looked missing from All. Now each new tile goes to the
       bottom of the shortest column and nothing already there moves. Heights are counted in tile widths, guessed
       (EST) until the image loads. The column count still comes from the CSS column-count rules. */
    var cols = [], EST = 1.25;
    function colCount() { return Math.max(1, parseInt(getComputedStyle(grid).columnCount, 10) || 4); }
    function makeCols() {
      grid.innerHTML = ''; grid.classList.add('is-cols'); cols = [];
      for (var c = 0, n = colCount(); c < n; c++) { var col = document.createElement('div'); col.className = 'mv-lib__col'; col._h = 0; grid.appendChild(col); cols.push(col); }
    }
    function place(fig) {
      if (!cols.length) { makeCols(); }
      var best = cols[0];
      cols.forEach(function (c) { if (c._h < best._h - 0.01) { best = c; } });
      if (fig._est == null) { fig._est = EST; }
      best.appendChild(fig); fig._col = best; best._h += fig._est;
    }
    function firstTile() { return grid.querySelector('.mv-lib__tile'); }
    /* a different number of columns after a resize: lay the same tiles out again, in order */
    window.addEventListener('resize', function () {
      if (!cols.length || colCount() === cols.length) { return; }
      var tiles = Array.prototype.slice.call(grid.querySelectorAll('.mv-lib__tile'));
      makeCols(); tiles.forEach(place);
    });
    /* Phones have no hover, so the pink outline used to sit on every tile at once (20 Sep, Kaitlin: "on mobile it
       highlights every smart object in pink for the first few seconds, i prefer it to settle down and just exist on
       scroll"). Now a tile draws its outline once, as it scrolls into view, and then lets go. Nothing on load. */
    var peek = null;
    if (window.IntersectionObserver && window.matchMedia && matchMedia('(hover: none)').matches) {
      /* One tile at a time, a breath between them, and only the first few of the visit: a quiet hint, not a pink page.
         It stops for good once they have added their image. */
      var peekOn = null, peekAt = 0, peekLeft = 4, peekFrom = Date.now() + 900;
      peek = new IntersectionObserver(function (rows) {
        rows.forEach(function (row) {
          var f = row.target, now = Date.now();
          if (!row.isIntersecting || f._peeked || peekOn || peekLeft <= 0) { return; }
          if (now < peekFrom || now - peekAt < 1400 || app.classList.contains('has-art')) { return; }
          f._peeked = true; peekOn = f; peekLeft--; peekAt = now;
          f.classList.add('is-peek');
          setTimeout(function () { f.classList.remove('is-peek'); peekOn = null; peekAt = Date.now(); }, 2200);
        });
      }, { threshold: 0.55 });
    }
    function addBatch() {
      items.slice(shown, shown + BATCH).forEach(function (it, k) { var f = tile(it, shown + k); place(f); if (peek && f.classList.contains('has-area')) { peek.observe(f); } });
      shown = Math.min(items.length, shown + BATCH);
      end.hidden = shown < items.length;
      if (!end.hidden) {
        /* No counts anywhere (19 Sep, Kaitlin: "never say 174"). */
        end.textContent = cats[current] && cats[current].owned && !items.length ? 'Your purchased templates will appear here.' : items.length === all.filter(general).length ? 'That’s the whole library.' : cats[current] && cats[current].owned ? '' : cats[current] && cats[current].saved ? 'That’s everything you’ve saved. Tap the heart on any photo to add it here.' : 'That’s everything in this category. More under All.';
      }
    }
    function fill() {
      if (shown >= items.length) { return; }
      if (more.getBoundingClientRect().top < window.innerHeight + 900) { addBatch(); requestAnimationFrame(fill); }
    }
    var current = 0;
    /* All is the category with no filter on it. */
    function allIndex() { var a = 0; cats.forEach(function (c, k) { if (!c.test) { a = k; } }); return a; }
    function general(it) { return !it.oo; }
    function setCategory(i) {
      closeFocus(true);
      var test = cats[i].test;
      current = i;
      items = test ? all.filter(test) : all.slice();
      if (!cats[i].owned) { items = items.filter(general); }
      shown = 0; makeCols(); end.hidden = true;
      if (note) { note.hidden = true; }
      mineTab = 'bought'; drawMine(!!cats[i].owned);
      /* the tab bar shows what is in front: a pane if one is open, else the library's own category */
      if (dockMark) { dockMark(railPane() === 'create' && cats[i].owned ? 'mine' : railPane()); }
      Array.prototype.forEach.call(chipsEl.children, function (c) { if (c._i !== undefined) { c.setAttribute('aria-pressed', c._i === i ? 'true' : 'false'); } });
      if (scroller) { scroller.scrollTop = 0; }
      if (cats[i].owned) { loadPaidVideos(); return; }
      addBatch(); fill();
    }
    /* Mine is one page for their templates (3 Nov, Kaitlin: "make mine tab less confusing"): Bought (free to use)
       and Saved (their hearts), each with a one-line empty state, no chips. Tiles are ordinary tiles, so opening one
       big, adding a photo and Adjust all work the same. Anything hearted shows under Saved, bought or not (3 Nov, Kaitlin:
       "i just hearted a video but its not in saved tab": it was one she'd paid for, so it only sat under Bought). */
    var mineBox = null, mineTab = 'bought';
    function drawMine(on) {
      app.classList.toggle('is-mine', on);
      if (!on) { if (mineBox) { mineBox.hidden = true; mineBox.innerHTML = ''; } return; }
      if (!mineBox) { mineBox = document.createElement('div'); mineBox.className = 'mv-mine'; grid.parentNode.insertBefore(mineBox, grid); }
      mineBox.innerHTML = ''; mineBox.hidden = false;
      var title = document.createElement('p'); title.className = 'mv-mine__title'; title.textContent = 'Mine';
      mineBox.appendChild(title);
      var bought = all.filter(isOwned), saved = all.filter(function (it) { return hearts[it.u] && general(it); });
      /* Video templates too (3 Nov, Kaitlin: "the mine tab should contain video templates too"): Bought = a video
         template they've paid for a video on (/vlist, u), Saved = a video card they've hearted ('v:' + uuid). */
      var vBought = vidCards().filter(function (c) { return paidVid[c.u]; });
      var vSaved = vidCards().filter(function (c) { return hearts['v:' + c.u]; });
      /* Bought | Saved are two tabs at the top, one shown at a time (3 Nov, Kaitlin: "two tabs instead of Saved at the
         bottom of Bought"). It always opens on Bought (Kaitlin: "should open on bought first not saved"). */
      var secs = [['bought', 'Bought', bought, vBought, 'Nothing bought yet.'], ['saved', 'Saved', saved, vSaved, 'Tap ♡ on any mockup to save it here.']];
      var bar = document.createElement('div'); bar.className = 'mv-mine__tabs'; bar.setAttribute('role', 'tablist');
      mineBox.appendChild(bar);
      secs.forEach(function (sec) {
        var t = button('mv-mine__tab', sec[1]); t.setAttribute('role', 'tab'); t.setAttribute('aria-selected', sec[0] === mineTab ? 'true' : 'false');
        t.addEventListener('click', function () { if (mineTab !== sec[0]) { mineTab = sec[0]; drawMine(true); } });
        bar.appendChild(t);
        if (sec[0] !== mineTab) { return; }
        if (!sec[2].length && !sec[3].length) {
          mineBox.appendChild(Object.assign(document.createElement('p'), { className: 'mv-mine__empty', textContent: sec[4] }));
          return;
        }
        var g = document.createElement('div'); g.className = 'mv-mine__grid';
        sec[2].forEach(function (it, k) { g.appendChild(tile(it, k)); });
        sec[3].forEach(function (c) { g.appendChild(vidTile(c)); });
        mineBox.appendChild(g);
      });
    }
    /* ---- video templates in Mine ---- */
    var paidVid = {}, vidListed = false;
    function vidCards() {
      return Array.prototype.map.call(document.querySelectorAll('.mv-vid__card[data-mxv-open]'), function (b) {
        var im = b.querySelector('.mv-vid__shot img');
        return { u: b.getAttribute('data-mxv-open'), btn: b, src: im ? (im.currentSrc || im.src) : '', n: b.getAttribute('data-name') || 'Video' };
      });
    }
    /* One tile per video template: its card photo, a VIDEO tag, and Create video, which opens the editor in the
       Video tab exactly as tapping the card there does. */
    function vidTile(c) {
      var fig = document.createElement('figure'); fig.className = 'mv-lib__tile mv-mine__vid is-loaded';
      var shot = document.createElement('div'); shot.className = 'mv-lib__shot';
      var im = document.createElement('img'); im.alt = c.n; im.src = c.src; im.loading = 'lazy';
      shot.appendChild(im);
      shot.appendChild(Object.assign(document.createElement('span'), { className: 'mv-lib__tag mv-mine__vtag', textContent: 'Video' }));
      var cap = document.createElement('figcaption');
      cap.appendChild(Object.assign(document.createElement('span'), { className: 'mv-lib__name', textContent: 'Create video →' }));
      fig.appendChild(shot); fig.appendChild(cap);
      fig.tabIndex = 0;
      fig.addEventListener('click', function () {
        /* out of Mine first: it is a page of its own, and the editor needs the studio around it */
        setCategory(allIndex());
        var vt = document.querySelector('[data-lib-tab="video"]');
        if (vt && vt.getAttribute('aria-selected') !== 'true') { vt.click(); }
        c.btn.click();
      });
      return fig;
    }
    /* Which video templates they've paid for: once, then Mine redraws if it's open. */
    function loadPaidVideos() {
      if (vidListed || guest || !token) { return; }
      vidListed = true;
      fetch(endpoint + '/vlist?token=' + encodeURIComponent(token)).then(function (r) { return r.json(); }).then(function (b) {
        (b.videos || []).forEach(function (v) { if (v.u && v.m) { paidVid[v.m] = 1; } });
        if (app.classList.contains('is-mine')) { drawMine(true); }
      }).catch(function () {});
    }
    /* Hearts on the video cards, same as the photo tiles (signed in only). A span, because the card is a button. */
    if (!guest) {
      Array.prototype.forEach.call(document.querySelectorAll('.mv-vid__card[data-mxv-open] .mv-vid__shot'), function (shotEl) {
        var u = 'v:' + shotEl.closest('[data-mxv-open]').getAttribute('data-mxv-open');
        var h = document.createElement('span'); h.className = 'mv-lib__heart mv-vid__heart'; h.setAttribute('role', 'button'); h.tabIndex = 0;
        h.setAttribute('aria-label', 'Save this video template');
        h.innerHTML = '<svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true"><path d="M12 20.5s-7.5-4.6-9.3-9.2C1.5 8.2 3.4 4.5 7 4.5c2.1 0 3.6 1.2 5 3 1.4-1.8 2.9-3 5-3 3.6 0 5.5 3.7 4.3 6.8-1.8 4.6-9.3 9.2-9.3 9.2z"/></svg>';
        var paint = function () { h.classList.toggle('is-on', !!hearts[u]); h.setAttribute('aria-pressed', hearts[u] ? 'true' : 'false'); };
        var flip = function (e) {
          e.stopPropagation(); e.preventDefault();
          if (hearts[u]) { delete hearts[u]; } else { hearts[u] = 1; h.classList.remove('is-pop'); void h.offsetWidth; h.classList.add('is-pop'); }
          paint(); saveHearts();
        };
        h.addEventListener('click', flip);
        h.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { flip(e); } });
        paint(); shotEl.appendChild(h);
      });
    }

    /* The library waits for /usage too, so it knows which templates they own before drawing (a failed /usage still draws it). */
    var ready = Promise.all([fetch(app.getAttribute('data-library')).then(function (r) { return r.json(); }), usageReady, pendingLoaded]).then(function (res) {
      /* Kaitlin's order, not shuffled (24 Oct, Kaitlin: "choose the order of mockups shown… currently it always
         refreshes random"). me-library.json is written in the order she sets on the Mockup Order page. */
      all = res[0].slice();
      /* Private templates (30 Sep): "pv" is the one customer id allowed to see it. The worker checks it too, so
         knowing the uuid gets nobody a render. A guest has no token, so they see none of them. */
      var meCid = (token || '').split('.')[0];
      all = all.filter(function (it) { return !it.pv || it.pv === meCid; });
      /* Owners only (3 Nov, Kaitlin: "never remove the ones i have removed from store from peoples mine tab"): "oo" is
         a template taken out of the store that its past buyers keep. It's kept only for someone who owns it, and even
         then only shows under Mine, never in All or a category. The worker refuses it to anyone else. */
      all = all.filter(function (it) { return !it.oo || isOwned(it); });
      /* Signed out: the one they can actually make goes first, top left, and the rest are locked until they have an
         account (23 Sep, Kaitlin: "should it have the new york billboard at the top left as thats the free one and a
         lock on the rest BEFORE they create an account"). The worker's /free puts a logo on this same template. */
      if (guest && !pendingFile) {
        var gAt = -1;
        all.forEach(function (it, k) { if (gAt < 0 && /vertical city billboard/i.test(it.n)) { gAt = k; } });
        if (gAt >= 0) { starter = all.splice(gAt, 1)[0]; all.unshift(starter); }
      }
      /* Came from the home page with a logo: its template goes first and gets made straight away. */
      if (pendingFile) {
        var want = /vertical city billboard/i;
        var at = -1;
        all.forEach(function (it, k) { if (at < 0 && want.test(it.n)) { at = k; } });
        if (at >= 0) { starter = all.splice(at, 1)[0]; all.unshift(starter); }
      }
      /* Picked in the chat (me-chat.js): /pages/creator-studio?t=<template uuid> puts that template first. */
      var pinned = null;
      try {
        var tq = new URLSearchParams(location.search).get('t'), pi = -1;
        if (tq && !starter) { all.forEach(function (it, k) { if (pi < 0 && it.u === tq) { pi = k; } }); }
        if (pi >= 0) { pinned = all.splice(pi, 1)[0]; all.unshift(pinned); }
      } catch (e) { pinned = null; }
      cats = CATEGORIES.map(function (cat) {
        if (cat[1] === 'video') { return { label: cat[0], test: function (it) { return !!videos[it.u]; }, video: true }; }
        return { label: cat[0], test: cat[0] === 'All' ? null : function (it) { return catOf(it) === cat[0]; } };
      });
      /* The owned category is always there for a signed-in customer (23 Sep, Kaitlin: "have a tab that says my
         templates… purchased"), so the phone tab bar always has somewhere to go. Its chip hides while it's empty,
         the way Saved does, and the library never STARTS on it unless there's something in it. */
      if (!guest) { cats.unshift({ label: ownedChip, test: isOwned, owned: true }); }
      /* No Saved chip: hearted templates live under Mine now, beside the bought ones (3 Nov, Kaitlin: "how can we
         make mine tab less confusing"). */
      cats.forEach(function (cat, i) {
        var pool = cat.owned ? all : all.filter(general);
        var count = cat.test ? pool.filter(cat.test).length : pool.length;
        if (!count && !cat.saved && !cat.owned) { return; }
        var chip = button('mv-lib__chip' + (cat.owned ? ' mv-lib__chip--mine' : '') + (cat.saved ? ' mv-lib__chip--saved' : ''), cat.label);
        chip._i = i;
        if (cat.saved) { savedChip = chip; chip.hidden = !count; }
        /* never shown as a chip (Kaitlin, 25 Sep: "remove boguht before bubble as now its under 'mine'").
           The category stays, because the Mine tab works by clicking this chip. */
        if (cat.owned) { mineChip = chip; chip.hidden = true; }
        chip.addEventListener('click', function () { setCategory(i); });
        chipsEl.appendChild(chip);
      });
      /* Sort (19 Sep, Kaitlin: "sort from newest to oldest or most popular"). Featured (Kaitlin's own order, the file order) by default.
         Newest / Oldest: d = the date it first became available (Shopify release date, or the day it came into the studio
         for ones never sold as singles); ties broken by Dynamic Mockups upload order (the id in the thumbnail URL).
         Most popular: p = all-time orders of its old product, plus images made in the studio (worker GET /popular).
         The choice is remembered in localStorage mx-lib-sort. */
      mixed = all.slice(); var sortBy = 'mixed', made = {};
      function uploadId(it) { var m = /\/mockup\/(\d+)\//.exec(it.t || ''); return m ? Number(m[1]) : 0; }
      function newer(a, b) { return (b.d || '') < (a.d || '') ? -1 : (b.d || '') > (a.d || '') ? 1 : uploadId(b) - uploadId(a); }
      function score(it) { return (it.p || 0) + (made[it.u] || 0); }
      try { sortBy = localStorage.getItem('mx-lib-sort') || (localStorage.getItem('mx-lib-newest') === '1' ? 'new' : 'mixed'); } catch (e) { sortBy = 'mixed'; }
      function applyOrder() {
        var list = mixed.slice();
        if (sortBy === 'new') { list.sort(newer); }
        else if (sortBy === 'old') { list.sort(function (a, b) { return newer(b, a); }); }
        else if (sortBy === 'popular') { list.sort(function (a, b) { return score(b) - score(a); }); }
        all = list;
        [pinned, starter].forEach(function (p) { if (p) { all.splice(all.indexOf(p), 1); all.unshift(p); } });
      }
      var sortWrap = document.createElement('label'); sortWrap.className = 'mv-lib__chip mv-lib__chip--sort';
      sortWrap.innerHTML = '<span>Sort</span><select aria-label="Sort the library"><option value="mixed">Featured</option><option value="popular">Most popular</option><option value="new">Newest</option><option value="old">Oldest</option></select>';
      var sortSel = sortWrap.querySelector('select');
      if (!sortSel.querySelector('option[value="' + sortBy + '"]')) { sortBy = 'mixed'; }
      sortSel.value = sortBy;
      sortSel.addEventListener('change', function () {
        sortBy = sortSel.value;
        try { localStorage.setItem('mx-lib-sort', sortBy); } catch (e) { /* ignore */ }
        applyOrder(); setCategory(current);
      });
      /* Blank | Examples (21 Sep, Kaitlin: "that inspiration on off should be clearer"). Was a switch at the far end of
         the chips, off screen on phones, so people saw "Example" photos with no way back. Now two words, always in
         view, on the Photo | Video row, the one showing is filled in. */
      if (inspoBase && all.some(function (it) { return it.f; })) {
        var view = document.createElement('div'); view.className = 'mv-view'; view.setAttribute('role', 'group'); view.setAttribute('aria-label', 'How the photos look');
        var viewBtns = [['0', 'Blank'], ['1', 'Examples']].map(function (o) {
          var b = button('mv-view__btn', o[1]); b.setAttribute('data-on', o[0]);
          b.addEventListener('click', function () {
            var on = o[0] === '1';
            setInspo(on);
            viewBtns.forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
            try { localStorage.setItem('mx-lib-inspo', on ? '1' : '0'); } catch (e) { /* ignore */ }
          });
          b.setAttribute('aria-pressed', (o[0] === '1') === inspoOn ? 'true' : 'false');
          view.appendChild(b);
          return b;
        });
        var folderRow = app.querySelector('.mv-folder');
        (folderRow || chipsEl).appendChild(view);
      }
      chipsEl.appendChild(sortWrap);
      /* View (Blank | Examples) and Sort sit in the top bar on a computer too (3 Nov, Kaitlin: the Create panel goes,
         "blank/example toggle where else"). They were in the left menu from 21 Sep. */
      if (sortBy !== 'mixed') { applyOrder(); }
      /* Studio makes, counted by the worker. Only re-sorts if they're looking at Most popular when it arrives. */
      fetch(endpoint + '/popular').then(function (r) { return r.ok ? r.json() : {}; }).then(function (m) {
        made = m && typeof m === 'object' ? m : {};
        if (sortBy === 'popular') { applyOrder(); setCategory(current); }
      }).catch(function () { /* sales alone still sort it */ });
      /* Always All (Kaitlin, 25 Sep: "it should go to create and then ALL"). It used to start on Bought before
         when they had some; those live under Mine now. */
      var startAt = 0;
      cats.forEach(function (c, k) { if (!c.test) { startAt = k; } });
      /* the Video link (/pages/creator-studio#video) opens on the Video chip */
      if (!starter && !pinned && location.hash === '#video') { cats.forEach(function (c, k) { if (c.video && all.some(c.test)) { startAt = k; } }); }
      setInspo(inspoOn);
      setCategory(startAt);
      var first = firstTile();
      if (pinned && first) { first.classList.add('is-flash'); }
      if (starter && first && first._first) { first._first(); }
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) { if (entries[0].isIntersecting) { fill(); } }, { root: scroller && getComputedStyle(scroller).overflowY === 'auto' ? scroller : null, rootMargin: '900px 0px' }).observe(more);
      }
      (scroller || window).addEventListener('scroll', fill, { passive: true });
      window.addEventListener('scroll', fill, { passive: true });
      if (scroller) { scroller.addEventListener('scroll', coachPlace, { passive: true }); }
      /* Nothing added yet: the first pop-up points at the upload in the rail (or their last image, if it's offered). */
      setTimeout(function () {
        if (art || uploading || made.length) { return; }
        var offer = again && !again.hidden;
        /* No Start here bubble (21 Sep, Kaitlin: "remove"). */ if (false) coach('start', offer ? again : drop, 'Start here.', offer ? 'Keep going with this one, or add a new one.' : 'Upload a photo.', 'right');
      }, 900);
    });
    libReady = ready;
    ready.catch(function () { showError('Could not load the library. Refresh to try again.'); });
    /* Made on earlier visits (worker GET /made, since 21 Sep), added under this visit's in the Made tray. */
    if (!guest) {
      ready.then(function () {
        return fetch(endpoint + '/made?token=' + encodeURIComponent(token)).then(function (r) { return r.ok ? r.json() : { made: [] }; });
      }).then(function (res) {
        var byU = {}; all.forEach(function (it) { byU[it.u] = it; });
        (res && res.made || []).forEach(function (m) { if (byU[m.u]) { made.push({ item: byU[m.u], state: { url: m.url, art: m.art }, s: m.s, past: true, at: m.at }); } });
        drawTray();
      }).catch(function () {});
    }
  }

  function run(root) { Array.prototype.forEach.call(root.querySelectorAll('[data-lib]'), wire); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', function () { run(document); }); } else { run(document); }
  document.addEventListener('shopify:section:load', function (e) { run(e.target); });
})();
